// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/event/event_requests.proto (package api.v1.event, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Money } from "../../google/type/money_pb";
import { file_google_type_money } from "../../google/type/money_pb";
import type { LatLng } from "../../google/type/latlng_pb";
import { file_google_type_latlng } from "../../google/type/latlng_pb";
import { file_v1_common_common_types } from "../common/common_types_pb";
import type { Pagination, PaginationRequest } from "../common/pagination_pb";
import { file_v1_common_pagination } from "../common/pagination_pb";
import type { AttendanceTimePoint, CheckInMethod, CollaboratorSearchResult, Event, EventAttendee, EventCollaborationType, EventCollaborator, EventCollaboratorDenialReason, EventCollaboratorEntityType, EventCollaboratorRequesteeStatus, EventCollaboratorRequesterStatus, EventStatus, EventType, EventVisibility, FAQ, Image, RecentCheckIn, RegistrationStatus } from "./event_types_pb";
import { file_v1_event_event_types } from "./event_types_pb";
import type { Image as Image$1 } from "../image/image_service_pb";
import { file_v1_image_image_service } from "../image/image_service_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/event/event_requests.proto.
 */
export const file_v1_event_event_requests: GenFile = /*@__PURE__*/
  fileDesc("Ch12MS9ldmVudC9ldmVudF9yZXF1ZXN0cy5wcm90bxIMYXBpLnYxLmV2ZW50IvcBChZFdmVudENvbGxhYm9yYXRvcklucHV0Ej4KC2VudGl0eV90eXBlGAEgASgOMikuYXBpLnYxLmV2ZW50LkV2ZW50Q29sbGFib3JhdG9yRW50aXR5VHlwZRIRCgllbnRpdHlfaWQYAiABKAkSQAoSY29sbGFib3JhdGlvbl90eXBlGAMgASgOMiQuYXBpLnYxLmV2ZW50LkV2ZW50Q29sbGFib3JhdGlvblR5cGUSSAoQcmVxdWVzdGVyX3N0YXR1cxgEIAEoDjIuLmFwaS52MS5ldmVudC5FdmVudENvbGxhYm9yYXRvclJlcXVlc3RlclN0YXR1cyK6BwoSQ3JlYXRlRXZlbnRSZXF1ZXN0EgoKAmlkGAEgASgJEg4KBm9yZ19pZBgCIAEoCRINCgV0aXRsZRgDIAEoCRITCgtkZXNjcmlwdGlvbhgEIAEoCRIrCgpldmVudF90eXBlGAUgASgOMhcuYXBpLnYxLmV2ZW50LkV2ZW50VHlwZRIXCgp0aWNrZXRfdXJsGAYgASgJSACIAQESPgoVcmVnaXN0cmF0aW9uX2RlYWRsaW5lGAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgBiAEBEiYKBXByaWNlGAggASgLMhIuZ29vZ2xlLnR5cGUuTW9uZXlIAogBARIVCghjYXBhY2l0eRgJIAEoBUgDiAEBEiMKBmltYWdlcxgKIAMoCzITLmFwaS52MS5ldmVudC5JbWFnZRIpCgZzdGF0dXMYCyABKA4yGS5hcGkudjEuZXZlbnQuRXZlbnRTdGF0dXMSDAoEdGFncxgMIAMoCRIuCgpzdGFydF9kYXRlGA0gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghlbmRfZGF0ZRgOIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEAoIdGltZXpvbmUYDyABKAkSEgoKdmVudWVfbmFtZRgQIAEoCRIPCgdhZGRyZXNzGBEgASgJEgwKBGNpdHkYEiABKAkSDQoFc3RhdGUYEyABKAkSEwoLcG9zdGFsX2NvZGUYFCABKAkSDwoHY291bnRyeRgVIAEoCRIQCghsYXRpdHVkZRgWIAEoARIRCglsb25naXR1ZGUYFyABKAESJgoLZmFxX2NvbnRlbnQYGCADKAsyES5hcGkudjEuZXZlbnQuRkFREjsKDWNvbGxhYm9yYXRvcnMYGSADKAsyJC5hcGkudjEuZXZlbnQuRXZlbnRDb2xsYWJvcmF0b3JJbnB1dBIgChNleHRlcm5hbF90aWNrZXRfdXJsGBogASgJSASIAQESMQoKdmlzaWJpbGl0eRgbIAEoDjIdLmFwaS52MS5ldmVudC5FdmVudFZpc2liaWxpdHkSHQoQZGVzY3JpcHRpb25fcmljaBgdIAEoCUgFiAEBQg0KC190aWNrZXRfdXJsQhgKFl9yZWdpc3RyYXRpb25fZGVhZGxpbmVCCAoGX3ByaWNlQgsKCV9jYXBhY2l0eUIWChRfZXh0ZXJuYWxfdGlja2V0X3VybEITChFfZGVzY3JpcHRpb25fcmljaCLiAQoTQ29sbGFib3JhdG9yRmFpbHVyZRIRCgllbnRpdHlfaWQYASABKAkSPgoLZW50aXR5X3R5cGUYAiABKA4yKS5hcGkudjEuZXZlbnQuRXZlbnRDb2xsYWJvcmF0b3JFbnRpdHlUeXBlEkAKEmNvbGxhYm9yYXRpb25fdHlwZRgDIAEoDjIkLmFwaS52MS5ldmVudC5FdmVudENvbGxhYm9yYXRpb25UeXBlEg0KBWVycm9yGAQgASgJEhQKDHVzZXJfbWVzc2FnZRgFIAEoCRIRCglyZXRyeWFibGUYBiABKAgidAoTQ3JlYXRlRXZlbnRSZXNwb25zZRIKCgJpZBgBIAEoCRIPCgdzdWNjZXNzGAIgASgIEkAKFWNvbGxhYm9yYXRvcl9mYWlsdXJlcxgDIAMoCzIhLmFwaS52MS5ldmVudC5Db2xsYWJvcmF0b3JGYWlsdXJlImMKD0dldEV2ZW50UmVxdWVzdBIKCgJpZBgBIAEoCRImChlpbmNsdWRlX2FsbF9jb2xsYWJvcmF0b3JzGAIgASgISACIAQFCHAoaX2luY2x1ZGVfYWxsX2NvbGxhYm9yYXRvcnMiqgcKElVwZGF0ZUV2ZW50UmVxdWVzdBIKCgJpZBgBIAEoCRINCgV0aXRsZRgCIAEoCRITCgtkZXNjcmlwdGlvbhgDIAEoCRIrCgpldmVudF90eXBlGAQgASgOMhcuYXBpLnYxLmV2ZW50LkV2ZW50VHlwZRIXCgp0aWNrZXRfdXJsGAUgASgJSACIAQESPgoVcmVnaXN0cmF0aW9uX2RlYWRsaW5lGAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgBiAEBEiYKBXByaWNlGAcgASgLMhIuZ29vZ2xlLnR5cGUuTW9uZXlIAogBARIVCghjYXBhY2l0eRgIIAEoBUgDiAEBEiMKBmltYWdlcxgJIAMoCzITLmFwaS52MS5ldmVudC5JbWFnZRIpCgZzdGF0dXMYCiABKA4yGS5hcGkudjEuZXZlbnQuRXZlbnRTdGF0dXMSDAoEdGFncxgLIAMoCRIuCgpzdGFydF9kYXRlGAwgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghlbmRfZGF0ZRgNIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEgoKdmVudWVfbmFtZRgOIAEoCRIPCgdhZGRyZXNzGA8gASgJEgwKBGNpdHkYECABKAkSDQoFc3RhdGUYESABKAkSEwoLcG9zdGFsX2NvZGUYEiABKAkSDwoHY291bnRyeRgTIAEoCRIQCghsYXRpdHVkZRgUIAEoARIRCglsb25naXR1ZGUYFSABKAESEAoIdGltZXpvbmUYFiABKAkSJgoLZmFxX2NvbnRlbnQYFyADKAsyES5hcGkudjEuZXZlbnQuRkFREjsKDWNvbGxhYm9yYXRvcnMYGCADKAsyJC5hcGkudjEuZXZlbnQuRXZlbnRDb2xsYWJvcmF0b3JJbnB1dBIgChNleHRlcm5hbF90aWNrZXRfdXJsGBkgASgJSASIAQESMQoKdmlzaWJpbGl0eRgaIAEoDjIdLmFwaS52MS5ldmVudC5FdmVudFZpc2liaWxpdHkSHQoQZGVzY3JpcHRpb25fcmljaBgcIAEoCUgFiAEBQg0KC190aWNrZXRfdXJsQhgKFl9yZWdpc3RyYXRpb25fZGVhZGxpbmVCCAoGX3ByaWNlQgsKCV9jYXBhY2l0eUIWChRfZXh0ZXJuYWxfdGlja2V0X3VybEITChFfZGVzY3JpcHRpb25fcmljaCIgChJEZWxldGVFdmVudFJlcXVlc3QSCgoCaWQYASABKAkiWAoVQ29tbXVuaXR5U2VhcmNoUGFyYW1zEiwKD2NlbnRlcl9sb2NhdGlvbhgBIAEoCzITLmdvb2dsZS50eXBlLkxhdExuZxIRCglyYWRpdXNfa20YAiABKAUiFAoSQmV5b25kU2VhcmNoUGFyYW1zIrQIChNTZWFyY2hFdmVudHNSZXF1ZXN0EjgKCWNvbW11bml0eRgBIAEoCzIjLmFwaS52MS5ldmVudC5Db21tdW5pdHlTZWFyY2hQYXJhbXNIABIyCgZiZXlvbmQYAiABKAsyIC5hcGkudjEuZXZlbnQuQmV5b25kU2VhcmNoUGFyYW1zSAASGQoMc2VhcmNoX3F1ZXJ5GAMgASgJSAGIAQESLAoLZXZlbnRfdHlwZXMYBCADKA4yFy5hcGkudjEuZXZlbnQuRXZlbnRUeXBlEisKCHN0YXR1c2VzGAUgAygOMhkuYXBpLnYxLmV2ZW50LkV2ZW50U3RhdHVzEhQKDGNhdGVnb3J5X2lkcxgGIAMoCRIRCgl0YWdfbmFtZXMYByADKAkSOQoQc3RhcnRfZGF0ZV9hZnRlchgIIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAogBARI6ChFzdGFydF9kYXRlX2JlZm9yZRgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIA4gBARI3Cg5lbmRfZGF0ZV9hZnRlchgKIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIBIgBARI4Cg9lbmRfZGF0ZV9iZWZvcmUYCyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAWIAQESFgoJbWluX3ByaWNlGAwgASgBSAaIAQESFgoJbWF4X3ByaWNlGA0gASgBSAeIAQESGQoMbWluX2NhcGFjaXR5GA4gASgFSAiIAQESGQoMbWF4X2NhcGFjaXR5GA8gASgFSAmIAQESHgoWaW5jbHVkZV92aXJ0dWFsX2V2ZW50cxgQIAEoCBIbChNpbmNsdWRlX2Z1bGxfZXZlbnRzGBEgASgIEhMKBm9yZ19pZBgSIAEoCUgKiAEBEisKB3NvcnRfYnkYEyABKA4yGi5hcGkudjEuZXZlbnQuU2VhcmNoU29ydEJ5EhcKD3NvcnRfZGVzY2VuZGluZxgUIAEoCBI0CgpwYWdpbmF0aW9uGBUgASgLMiAuYXBpLnYxLmNvbW1vbi5QYWdpbmF0aW9uUmVxdWVzdBIzCgx2aXNpYmlsaXRpZXMYFiADKA4yHS5hcGkudjEuZXZlbnQuRXZlbnRWaXNpYmlsaXR5QhEKD2xvY2F0aW9uX3NlYXJjaEIPCg1fc2VhcmNoX3F1ZXJ5QhMKEV9zdGFydF9kYXRlX2FmdGVyQhQKEl9zdGFydF9kYXRlX2JlZm9yZUIRCg9fZW5kX2RhdGVfYWZ0ZXJCEgoQX2VuZF9kYXRlX2JlZm9yZUIMCgpfbWluX3ByaWNlQgwKCl9tYXhfcHJpY2VCDwoNX21pbl9jYXBhY2l0eUIPCg1fbWF4X2NhcGFjaXR5QgkKB19vcmdfaWQipAEKEUV2ZW50U2VhcmNoUmVzdWx0EiIKBWV2ZW50GAEgASgLMhMuYXBpLnYxLmV2ZW50LkV2ZW50EjYKDWRpc3RhbmNlX2luZm8YAiABKAsyGi5hcGkudjEuZXZlbnQuRGlzdGFuY2VJbmZvSACIAQESIQoZaXNfaW5fdXNlcl9wcmVmZXJyZWRfYXJlYRgDIAEoCEIQCg5fZGlzdGFuY2VfaW5mbyLtAQoUU2VhcmNoRXZlbnRzUmVzcG9uc2USLwoGZXZlbnRzGAEgAygLMh8uYXBpLnYxLmV2ZW50LkV2ZW50U2VhcmNoUmVzdWx0Ei0KCnBhZ2luYXRpb24YAiABKAsyGS5hcGkudjEuY29tbW9uLlBhZ2luYXRpb24SLwoNc2VhcmNoX2NlbnRlchgDIAEoCzITLmdvb2dsZS50eXBlLkxhdExuZ0gAiAEBEh0KEHNlYXJjaF9yYWRpdXNfa20YBCABKAVIAYgBAUIQCg5fc2VhcmNoX2NlbnRlckITChFfc2VhcmNoX3JhZGl1c19rbSIYChZHZW5lcmF0ZUV2ZW50SWRSZXF1ZXN0IiUKF0dlbmVyYXRlRXZlbnRJZFJlc3BvbnNlEgoKAmlkGAEgASgJIjgKEkNyZWF0ZUltYWdlUmVxdWVzdBIiCgVpbWFnZRgBIAEoCzITLmFwaS52MS5pbWFnZS5JbWFnZSIhChNJc1NhdmVkRXZlbnRSZXF1ZXN0EgoKAmlkGAEgASgJIigKFElzU2F2ZWRFdmVudFJlc3BvbnNlEhAKCGlzX3NhdmVkGAEgASgIIoUBChRSZWdpc3RlckV2ZW50UmVxdWVzdBIQCghldmVudF9pZBgBIAEoCRINCgVlbWFpbBgCIAEoCRIXCgpmaXJzdF9uYW1lGAMgASgJSACIAQESFgoJbGFzdF9uYW1lGAQgASgJSAGIAQFCDQoLX2ZpcnN0X25hbWVCDAoKX2xhc3RfbmFtZSJNChVSZWdpc3RlckV2ZW50UmVzcG9uc2USHgoRcXJfY29kZV9pbWFnZV91cmwYASABKAlIAIgBAUIUChJfcXJfY29kZV9pbWFnZV91cmwiLQoZQ2FuY2VsUmVnaXN0cmF0aW9uUmVxdWVzdBIQCghldmVudF9pZBgBIAEoCSIwChxHZXRSZWdpc3RyYXRpb25TdGF0dXNSZXF1ZXN0EhAKCGV2ZW50X2lkGAEgASgJIuIBCh1HZXRSZWdpc3RyYXRpb25TdGF0dXNSZXNwb25zZRIwCgZzdGF0dXMYASABKA4yIC5hcGkudjEuZXZlbnQuUmVnaXN0cmF0aW9uU3RhdHVzEjoKEXJlZ2lzdHJhdGlvbl9kYXRlGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBEhcKD2Nhbl9nZXRfcXJfY29kZRgDIAEoCBIWCgl0aWNrZXRfaWQYBCABKAlIAYgBAUIUChJfcmVnaXN0cmF0aW9uX2RhdGVCDAoKX3RpY2tldF9pZCIsChhHZXRBdHRlbmRlZVFSQ29kZVJlcXVlc3QSEAoIZXZlbnRfaWQYASABKAki1QEKGUdldEF0dGVuZGVlUVJDb2RlUmVzcG9uc2USEwoLcXJfY29kZV91cmwYASABKAkSDQoFdG9rZW4YAiABKAkSLgoKZXhwaXJlc19hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASGgoSYWxyZWFkeV9jaGVja2VkX2luGAQgASgIEjYKDWNoZWNrZWRfaW5fYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQFCEAoOX2NoZWNrZWRfaW5fYXQibwoWQ2hlY2tJbkF0dGVuZGVlUmVxdWVzdBINCgV0b2tlbhgBIAEoCRIQCghldmVudF9pZBgCIAEoCRI0Cg9jaGVja19pbl9tZXRob2QYAyABKA4yGy5hcGkudjEuZXZlbnQuQ2hlY2tJbk1ldGhvZCK8AQoXQ2hlY2tJbkF0dGVuZGVlUmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCBISCgVlcnJvchgCIAEoCUgAiAEBEjIKCGF0dGVuZGVlGAMgASgLMhsuYXBpLnYxLmV2ZW50LkV2ZW50QXR0ZW5kZWVIAYgBARInCgVldmVudBgEIAEoCzITLmFwaS52MS5ldmVudC5FdmVudEgCiAEBQggKBl9lcnJvckILCglfYXR0ZW5kZWVCCAoGX2V2ZW50Ii0KGUdldEV2ZW50QXR0ZW5kYW5jZVJlcXVlc3QSEAoIZXZlbnRfaWQYASABKAki9gEKGkdldEV2ZW50QXR0ZW5kYW5jZVJlc3BvbnNlEhsKE3RvdGFsX3JlZ2lzdHJhdGlvbnMYASABKAUSGAoQY2hlY2tlZF9pbl9jb3VudBgCIAEoBRIcChRub3RfY2hlY2tlZF9pbl9jb3VudBgDIAEoBRIXCg9hdHRlbmRhbmNlX3JhdGUYBCABKAESNQoQcmVjZW50X2NoZWNrX2lucxgFIAMoCzIbLmFwaS52MS5ldmVudC5SZWNlbnRDaGVja0luEjMKCHRpbWVsaW5lGAYgAygLMiEuYXBpLnYxLmV2ZW50LkF0dGVuZGFuY2VUaW1lUG9pbnQimgQKFExpc3RBdHRlbmRlZXNSZXF1ZXN0EhAKCGV2ZW50X2lkGAEgASgJEjkKCnBhZ2luYXRpb24YAiABKAsyIC5hcGkudjEuY29tbW9uLlBhZ2luYXRpb25SZXF1ZXN0SACIAQESHAoPY2hlY2tlZF9pbl9vbmx5GAMgASgISAGIAQESIAoTbm90X2NoZWNrZWRfaW5fb25seRgEIAEoCEgCiAEBEhkKDHNlYXJjaF9xdWVyeRgFIAEoCUgDiAEBEkIKB3NvcnRfYnkYBiABKA4yLC5hcGkudjEuZXZlbnQuTGlzdEF0dGVuZGVlc1JlcXVlc3QuU29ydEZpZWxkSASIAQESHAoPc29ydF9kZXNjZW5kaW5nGAcgASgISAWIAQEiiwEKCVNvcnRGaWVsZBIaChZTT1JUX0ZJRUxEX1VOU1BFQ0lGSUVEEAASEwoPU09SVF9GSUVMRF9OQU1FEAESFAoQU09SVF9GSUVMRF9FTUFJTBACEhkKFVNPUlRfRklFTERfQ1JFQVRFRF9BVBADEhwKGFNPUlRfRklFTERfQ0hFQ0tFRF9JTl9BVBAEQg0KC19wYWdpbmF0aW9uQhIKEF9jaGVja2VkX2luX29ubHlCFgoUX25vdF9jaGVja2VkX2luX29ubHlCDwoNX3NlYXJjaF9xdWVyeUIKCghfc29ydF9ieUISChBfc29ydF9kZXNjZW5kaW5nItcBChVMaXN0QXR0ZW5kZWVzUmVzcG9uc2USLgoJYXR0ZW5kZWVzGAEgAygLMhsuYXBpLnYxLmV2ZW50LkV2ZW50QXR0ZW5kZWUSMgoKcGFnaW5hdGlvbhgCIAEoCzIZLmFwaS52MS5jb21tb24uUGFnaW5hdGlvbkgAiAEBEhMKC3RvdGFsX2NvdW50GAMgASgFEhgKEGNoZWNrZWRfaW5fY291bnQYBCABKAUSHAoUbm90X2NoZWNrZWRfaW5fY291bnQYBSABKAVCDQoLX3BhZ2luYXRpb24iiQIKFkFkZENvbGxhYm9yYXRvclJlcXVlc3QSEAoIZXZlbnRfaWQYASABKAkSPgoLZW50aXR5X3R5cGUYAiABKA4yKS5hcGkudjEuZXZlbnQuRXZlbnRDb2xsYWJvcmF0b3JFbnRpdHlUeXBlEhEKCWVudGl0eV9pZBgDIAEoCRJAChJjb2xsYWJvcmF0aW9uX3R5cGUYBCABKA4yJC5hcGkudjEuZXZlbnQuRXZlbnRDb2xsYWJvcmF0aW9uVHlwZRJIChByZXF1ZXN0ZXJfc3RhdHVzGAUgASgOMi4uYXBpLnYxLmV2ZW50LkV2ZW50Q29sbGFib3JhdG9yUmVxdWVzdGVyU3RhdHVzIiUKF0FkZENvbGxhYm9yYXRvclJlc3BvbnNlEgoKAmlkGAEgASgJIiQKFkdldENvbGxhYm9yYXRvclJlcXVlc3QSCgoCaWQYASABKAkiUAoXR2V0Q29sbGFib3JhdG9yUmVzcG9uc2USNQoMY29sbGFib3JhdG9yGAEgASgLMh8uYXBpLnYxLmV2ZW50LkV2ZW50Q29sbGFib3JhdG9yIvoBCiFMaXN0Q29sbGFib3JhdGlvbnNCeUVudGl0eVJlcXVlc3QSPgoLZW50aXR5X3R5cGUYASABKA4yKS5hcGkudjEuZXZlbnQuRXZlbnRDb2xsYWJvcmF0b3JFbnRpdHlUeXBlEhEKCWVudGl0eV9pZBgCIAEoCRI5CgpwYWdpbmF0aW9uGAMgASgLMiAuYXBpLnYxLmNvbW1vbi5QYWdpbmF0aW9uUmVxdWVzdEgAiAEBEiAKE2luY2x1ZGVfcGFzdF9ldmVudHMYBCABKAhIAYgBAUINCgtfcGFnaW5hdGlvbkIWChRfaW5jbHVkZV9wYXN0X2V2ZW50cyLFAgoiTGlzdENvbGxhYm9yYXRpb25zQnlFbnRpdHlSZXNwb25zZRJoChhldmVudHNfd2l0aF9jb2xsYWJvcmF0b3IYASADKAsyRi5hcGkudjEuZXZlbnQuTGlzdENvbGxhYm9yYXRpb25zQnlFbnRpdHlSZXNwb25zZS5FdmVudFdpdGhDb2xsYWJvcmF0b3ISMgoKcGFnaW5hdGlvbhgCIAEoCzIZLmFwaS52MS5jb21tb24uUGFnaW5hdGlvbkgAiAEBGnIKFUV2ZW50V2l0aENvbGxhYm9yYXRvchIiCgVldmVudBgBIAEoCzITLmFwaS52MS5ldmVudC5FdmVudBI1Cgxjb2xsYWJvcmF0b3IYAiABKAsyHy5hcGkudjEuZXZlbnQuRXZlbnRDb2xsYWJvcmF0b3JCDQoLX3BhZ2luYXRpb24ikQIKHUxpc3RFdmVudENvbGxhYm9yYXRvcnNSZXF1ZXN0EhAKCGV2ZW50X2lkGAEgASgJEjkKCnBhZ2luYXRpb24YAiABKAsyIC5hcGkudjEuY29tbW9uLlBhZ2luYXRpb25SZXF1ZXN0SACIAQESPgoLdHlwZV9maWx0ZXIYAyABKA4yJC5hcGkudjEuZXZlbnQuRXZlbnRDb2xsYWJvcmF0aW9uVHlwZUgBiAEBEiYKGWluY2x1ZGVfYWxsX2NvbGxhYm9yYXRvcnMYBCABKAhIAogBAUINCgtfcGFnaW5hdGlvbkIOCgxfdHlwZV9maWx0ZXJCHAoaX2luY2x1ZGVfYWxsX2NvbGxhYm9yYXRvcnMimwEKHkxpc3RFdmVudENvbGxhYm9yYXRvcnNSZXNwb25zZRI2Cg1jb2xsYWJvcmF0b3JzGAEgAygLMh8uYXBpLnYxLmV2ZW50LkV2ZW50Q29sbGFib3JhdG9yEjIKCnBhZ2luYXRpb24YAiABKAsyGS5hcGkudjEuY29tbW9uLlBhZ2luYXRpb25IAIgBAUINCgtfcGFnaW5hdGlvbiKHAQogTGlzdFBlbmRpbmdDb2xsYWJvcmF0aW9uc1JlcXVlc3QSEAoIZXZlbnRfaWQYASABKAkSPgoLZW50aXR5X3R5cGUYAiABKA4yKS5hcGkudjEuZXZlbnQuRXZlbnRDb2xsYWJvcmF0b3JFbnRpdHlUeXBlEhEKCWVudGl0eV9pZBgDIAEoCSJbCiFMaXN0UGVuZGluZ0NvbGxhYm9yYXRpb25zUmVzcG9uc2USNgoNY29sbGFib3JhdG9ycxgBIAMoCzIfLmFwaS52MS5ldmVudC5FdmVudENvbGxhYm9yYXRvciI5ChlSZW1vdmVDb2xsYWJvcmF0b3JSZXF1ZXN0EhAKCGV2ZW50X2lkGAEgASgJEgoKAmlkGAIgASgJIsUBChlTZWFyY2hVc2Vyc0FuZE9yZ3NSZXF1ZXN0Eg0KBXF1ZXJ5GAEgASgJEhQKDGV4Y2x1ZGVfb3JncxgCIAMoCRIVCg1leGNsdWRlX3VzZXJzGAMgAygJEhIKBWxpbWl0GAQgASgFSACIAQESPgoLdHlwZV9maWx0ZXIYBSABKA4yJC5hcGkudjEuZXZlbnQuRXZlbnRDb2xsYWJvcmF0aW9uVHlwZUgBiAEBQggKBl9saW1pdEIOCgxfdHlwZV9maWx0ZXIiZwoaU2VhcmNoVXNlcnNBbmRPcmdzUmVzcG9uc2USNwoHcmVzdWx0cxgBIAMoCzImLmFwaS52MS5ldmVudC5Db2xsYWJvcmF0b3JTZWFyY2hSZXN1bHQSEAoIaGFzX21vcmUYAiABKAgipgQKGVVwZGF0ZUNvbGxhYm9yYXRvclJlcXVlc3QSEAoIZXZlbnRfaWQYASABKAkSCgoCaWQYAiABKAkSRQoSY29sbGFib3JhdGlvbl90eXBlGAMgASgOMiQuYXBpLnYxLmV2ZW50LkV2ZW50Q29sbGFib3JhdGlvblR5cGVIAYgBARJKChByZXF1ZXN0ZXJfc3RhdHVzGAQgASgOMi4uYXBpLnYxLmV2ZW50LkV2ZW50Q29sbGFib3JhdG9yUmVxdWVzdGVyU3RhdHVzSAASVwoQcmVxdWVzdGVlX3N0YXR1cxgFIAEoCzI7LmFwaS52MS5ldmVudC5VcGRhdGVDb2xsYWJvcmF0b3JSZXF1ZXN0LlJlcXVlc3RlZVN0YXR1c0luZm9IABrdAQoTUmVxdWVzdGVlU3RhdHVzSW5mbxJIChByZXF1ZXN0ZWVfc3RhdHVzGAEgASgOMi4uYXBpLnYxLmV2ZW50LkV2ZW50Q29sbGFib3JhdG9yUmVxdWVzdGVlU3RhdHVzEkIKDWRlbmlhbF9yZWFzb24YAiABKA4yKy5hcGkudjEuZXZlbnQuRXZlbnRDb2xsYWJvcmF0b3JEZW5pYWxSZWFzb24SIAoTZGVuaWFsX3JlYXNvbl9vdGhlchgDIAEoCUgAiAEBQhYKFF9kZW5pYWxfcmVhc29uX290aGVyQggKBnN0YXR1c0IVChNfY29sbGFib3JhdGlvbl90eXBlIqcCCihVcGRhdGVDb2xsYWJvcmF0b3JSZXF1ZXN0ZWVTdGF0dXNSZXF1ZXN0EhAKCGV2ZW50X2lkGAEgASgJEgoKAmlkGAIgASgJEkgKEHJlcXVlc3RlZV9zdGF0dXMYAyABKA4yLi5hcGkudjEuZXZlbnQuRXZlbnRDb2xsYWJvcmF0b3JSZXF1ZXN0ZWVTdGF0dXMSRwoNZGVuaWFsX3JlYXNvbhgEIAEoDjIrLmFwaS52MS5ldmVudC5FdmVudENvbGxhYm9yYXRvckRlbmlhbFJlYXNvbkgAiAEBEiAKE2RlbmlhbF9yZWFzb25fb3RoZXIYBSABKAlIAYgBAUIQCg5fZGVuaWFsX3JlYXNvbkIWChRfZGVuaWFsX3JlYXNvbl9vdGhlciLMBAoeR2V0VXNlclJlZ2lzdGVyZWRFdmVudHNSZXF1ZXN0EjkKCnBhZ2luYXRpb24YASABKAsyIC5hcGkudjEuY29tbW9uLlBhZ2luYXRpb25SZXF1ZXN0SACIAQESIAoTaW5jbHVkZV9wYXN0X2V2ZW50cxgCIAEoCEgBiAEBEhoKDXVwY29taW5nX29ubHkYAyABKAhIAogBARI3Cg1zdGF0dXNfZmlsdGVyGAQgAygOMiAuYXBpLnYxLmV2ZW50LlJlZ2lzdHJhdGlvblN0YXR1cxIZCgxzZWFyY2hfcXVlcnkYBSABKAlIA4gBARJMCgdzb3J0X2J5GAYgASgOMjYuYXBpLnYxLmV2ZW50LkdldFVzZXJSZWdpc3RlcmVkRXZlbnRzUmVxdWVzdC5Tb3J0RmllbGRIBIgBARIcCg9zb3J0X2Rlc2NlbmRpbmcYByABKAhIBYgBASKGAQoJU29ydEZpZWxkEhoKFlNPUlRfRklFTERfVU5TUEVDSUZJRUQQABIgChxTT1JUX0ZJRUxEX1JFR0lTVFJBVElPTl9EQVRFEAESHwobU09SVF9GSUVMRF9FVkVOVF9TVEFSVF9EQVRFEAISGgoWU09SVF9GSUVMRF9FVkVOVF9USVRMRRADQg0KC19wYWdpbmF0aW9uQhYKFF9pbmNsdWRlX3Bhc3RfZXZlbnRzQhAKDl91cGNvbWluZ19vbmx5Qg8KDV9zZWFyY2hfcXVlcnlCCgoIX3NvcnRfYnlCEgoQX3NvcnRfZGVzY2VuZGluZyKTAgoTVXNlclJlZ2lzdGVyZWRFdmVudBIiCgVldmVudBgBIAEoCzITLmFwaS52MS5ldmVudC5FdmVudBI9ChNyZWdpc3RyYXRpb25fc3RhdHVzGAIgASgOMiAuYXBpLnYxLmV2ZW50LlJlZ2lzdHJhdGlvblN0YXR1cxI1ChFyZWdpc3RyYXRpb25fZGF0ZRgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASGAoLcXJfY29kZV91cmwYBCABKAlIAIgBARISCgpjYW5fY2FuY2VsGAUgASgIEhYKCXRpY2tldF9pZBgGIAEoCUgBiAEBQg4KDF9xcl9jb2RlX3VybEIMCgpfdGlja2V0X2lkIuMBCh9HZXRVc2VyUmVnaXN0ZXJlZEV2ZW50c1Jlc3BvbnNlEjwKEXJlZ2lzdGVyZWRfZXZlbnRzGAEgAygLMiEuYXBpLnYxLmV2ZW50LlVzZXJSZWdpc3RlcmVkRXZlbnQSMgoKcGFnaW5hdGlvbhgCIAEoCzIZLmFwaS52MS5jb21tb24uUGFnaW5hdGlvbkgAiAEBEhMKC3RvdGFsX2NvdW50GAMgASgFEhYKDnVwY29taW5nX2NvdW50GAQgASgFEhIKCnBhc3RfY291bnQYBSABKAVCDQoLX3BhZ2luYXRpb24iVwoMRGlzdGFuY2VJbmZvEhMKC2Rpc3RhbmNlX2ttGAEgASgBEhYKDmRpc3RhbmNlX21pbGVzGAIgASgBEhoKEmZvcm1hdHRlZF9kaXN0YW5jZRgDIAEoCSKNAQoRRXZlbnRXaXRoRGlzdGFuY2USIgoFZXZlbnQYASABKAsyEy5hcGkudjEuZXZlbnQuRXZlbnQSMQoNZGlzdGFuY2VfaW5mbxgCIAEoCzIaLmFwaS52MS5ldmVudC5EaXN0YW5jZUluZm8SIQoZaXNfaW5fdXNlcl9wcmVmZXJyZWRfYXJlYRgDIAEoCCLBBQoWR2V0TmVhcmJ5RXZlbnRzUmVxdWVzdBIPCgd1c2VyX2lkGAEgASgJEjMKEW92ZXJyaWRlX2xvY2F0aW9uGAIgASgLMhMuZ29vZ2xlLnR5cGUuTGF0TG5nSACIAQESHwoSb3ZlcnJpZGVfcmFkaXVzX2ttGAMgASgFSAGIAQESFQoNdXBjb21pbmdfb25seRgEIAEoCBIWCg5hdmFpbGFibGVfb25seRgFIAEoCBINCgVsaW1pdBgGIAEoBRJHCgp0aW1lX3JhbmdlGAcgASgOMi4uYXBpLnYxLmV2ZW50LkdldE5lYXJieUV2ZW50c1JlcXVlc3QuVGltZVJhbmdlSAKIAQESOgoRY3VzdG9tX3N0YXJ0X2RhdGUYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAOIAQESOAoPY3VzdG9tX2VuZF9kYXRlGAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgEiAEBEjYKFXByZWZlcnJlZF9ldmVudF90eXBlcxgKIAMoDjIXLmFwaS52MS5ldmVudC5FdmVudFR5cGUipAEKCVRpbWVSYW5nZRIaChZUSU1FX1JBTkdFX1VOU1BFQ0lGSUVEEAASFAoQVElNRV9SQU5HRV9UT0RBWRABEhgKFFRJTUVfUkFOR0VfVEhJU19XRUVLEAISGQoVVElNRV9SQU5HRV9USElTX01PTlRIEAMSGQoVVElNRV9SQU5HRV9ORVhUX01PTlRIEAQSFQoRVElNRV9SQU5HRV9DVVNUT00QBUIUChJfb3ZlcnJpZGVfbG9jYXRpb25CFQoTX292ZXJyaWRlX3JhZGl1c19rbUINCgtfdGltZV9yYW5nZUIUChJfY3VzdG9tX3N0YXJ0X2RhdGVCEgoQX2N1c3RvbV9lbmRfZGF0ZSK4AwoXR2V0TmVhcmJ5RXZlbnRzUmVzcG9uc2USNgoNbmVhcmJ5X2V2ZW50cxgBIAMoCzIfLmFwaS52MS5ldmVudC5FdmVudFdpdGhEaXN0YW5jZRIsCg9zZWFyY2hfbG9jYXRpb24YAiABKAsyEy5nb29nbGUudHlwZS5MYXRMbmcSGAoQc2VhcmNoX3JhZGl1c19rbRgDIAEoBRIdChV1c2VkX3VzZXJfcHJlZmVyZW5jZXMYBCABKAgSFwoPbG9jYXRpb25fc291cmNlGAUgASgJElkKDnJlY29tbWVuZGF0aW9uGAYgASgLMjwuYXBpLnYxLmV2ZW50LkdldE5lYXJieUV2ZW50c1Jlc3BvbnNlLkxvY2F0aW9uUmVjb21tZW5kYXRpb25IAIgBARp3ChZMb2NhdGlvblJlY29tbWVuZGF0aW9uEg8KB21lc3NhZ2UYASABKAkSLwoSc3VnZ2VzdGVkX2xvY2F0aW9uGAIgASgLMhMuZ29vZ2xlLnR5cGUuTGF0TG5nEhsKE3N1Z2dlc3RlZF9yYWRpdXNfa20YAyABKAVCEQoPX3JlY29tbWVuZGF0aW9uIoQDCiRHZXRFdmVudHNJblVzZXJQcmVmZXJyZWRBcmVhc1JlcXVlc3QSDwoHdXNlcl9pZBgBIAEoCRIVCg11cGNvbWluZ19vbmx5GAIgASgIEhYKDmF2YWlsYWJsZV9vbmx5GAMgASgIEhIKCmRheXNfYWhlYWQYBCABKAUSTwoHc29ydF9ieRgFIAEoDjI5LmFwaS52MS5ldmVudC5HZXRFdmVudHNJblVzZXJQcmVmZXJyZWRBcmVhc1JlcXVlc3QuU29ydEJ5SACIAQESNAoKcGFnaW5hdGlvbhgGIAEoCzIgLmFwaS52MS5jb21tb24uUGFnaW5hdGlvblJlcXVlc3QidQoGU29ydEJ5EhcKE1NPUlRfQllfVU5TUEVDSUZJRUQQABIVChFTT1JUX0JZX1JFTEVWQU5DRRABEhAKDFNPUlRfQllfREFURRACEhQKEFNPUlRfQllfRElTVEFOQ0UQAxITCg9TT1JUX0JZX1BPUFVMQVIQBEIKCghfc29ydF9ieSKqAwolR2V0RXZlbnRzSW5Vc2VyUHJlZmVycmVkQXJlYXNSZXNwb25zZRIvCgZldmVudHMYASADKAsyHy5hcGkudjEuZXZlbnQuRXZlbnRXaXRoRGlzdGFuY2USLQoKcGFnaW5hdGlvbhgCIAEoCzIZLmFwaS52MS5jb21tb24uUGFnaW5hdGlvbhJgCg5hcmVhc19zZWFyY2hlZBgDIAMoCzJILmFwaS52MS5ldmVudC5HZXRFdmVudHNJblVzZXJQcmVmZXJyZWRBcmVhc1Jlc3BvbnNlLlByZWZlcnJlZEFyZWFDb250ZXh0EhoKEnRvdGFsX2V2ZW50c19mb3VuZBgEIAEoBRIgChhoYXNfbG9jYXRpb25fcHJlZmVyZW5jZXMYBSABKAgagAEKFFByZWZlcnJlZEFyZWFDb250ZXh0EhEKCWFyZWFfbmFtZRgBIAEoCRIsCg9jZW50ZXJfbG9jYXRpb24YAiABKAsyEy5nb29nbGUudHlwZS5MYXRMbmcSEQoJcmFkaXVzX2ttGAMgASgFEhQKDGV2ZW50c19jb3VudBgEIAEoBSImChRJc09yZ1ZlcmlmaWVkUmVxdWVzdBIOCgZvcmdfaWQYASABKAkiLAoVSXNPcmdWZXJpZmllZFJlc3BvbnNlEhMKC2lzX3ZlcmlmaWVkGAEgASgIKn8KEkxvY2F0aW9uU2VhcmNoTW9kZRIkCiBMT0NBVElPTl9TRUFSQ0hfTU9ERV9VTlNQRUNJRklFRBAAEiIKHkxPQ0FUSU9OX1NFQVJDSF9NT0RFX0NPTU1VTklUWRABEh8KG0xPQ0FUSU9OX1NFQVJDSF9NT0RFX0JFWU9ORBACKr4BCgxTZWFyY2hTb3J0QnkSHgoaU0VBUkNIX1NPUlRfQllfVU5TUEVDSUZJRUQQABIbChdTRUFSQ0hfU09SVF9CWV9ESVNUQU5DRRABEhsKF1NFQVJDSF9TT1JUX0JZX1RSRU5ESU5HEAISGQoVU0VBUkNIX1NPUlRfQllfUkVDRU5UEAMSGgoWU0VBUkNIX1NPUlRfQllfUE9QVUxBUhAEEh0KGVNFQVJDSF9TT1JUX0JZX1NUQVJUX0RBVEUQBUK9AQoQY29tLmFwaS52MS5ldmVudEISRXZlbnRSZXF1ZXN0c1Byb3RvUAFaQ2dpdGh1Yi5jb20vZHdheW5lbGF2b24vbG9jYWwtY29tbXVuaXR5LXBsYXRmb3JtL2FwaS9nZW4vZ28vdjEvZXZlbnSiAgNBVkWqAgxBcGkuVjEuRXZlbnTKAgxBcGlcVjFcRXZlbnTiAhhBcGlcVjFcRXZlbnRcR1BCTWV0YWRhdGHqAg5BcGk6OlYxOjpFdmVudGIGcHJvdG8z", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_type_money, file_google_type_latlng, file_v1_common_common_types, file_v1_common_pagination, file_v1_event_event_types, file_v1_image_image_service]);

/**
 * @generated from message api.v1.event.EventCollaboratorInput
 */
export type EventCollaboratorInput = Message<"api.v1.event.EventCollaboratorInput"> & {
  /**
   * @generated from field: api.v1.event.EventCollaboratorEntityType entity_type = 1;
   */
  entityType: EventCollaboratorEntityType;

  /**
   * user_id or org_id
   *
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: api.v1.event.EventCollaborationType collaboration_type = 3;
   */
  collaborationType: EventCollaborationType;

  /**
   * @generated from field: api.v1.event.EventCollaboratorRequesterStatus requester_status = 4;
   */
  requesterStatus: EventCollaboratorRequesterStatus;
};

/**
 * Describes the message api.v1.event.EventCollaboratorInput.
 * Use `create(EventCollaboratorInputSchema)` to create a new message.
 */
export const EventCollaboratorInputSchema: GenMessage<EventCollaboratorInput> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 0);

/**
 * CreateEventRequest is the request to create an event
 *
 * @generated from message api.v1.event.CreateEventRequest
 */
export type CreateEventRequest = Message<"api.v1.event.CreateEventRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: api.v1.event.EventType event_type = 5;
   */
  eventType: EventType;

  /**
   * @generated from field: optional string ticket_url = 6;
   */
  ticketUrl?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp registration_deadline = 7;
   */
  registrationDeadline?: Timestamp;

  /**
   * @generated from field: optional google.type.Money price = 8;
   */
  price?: Money;

  /**
   * @generated from field: optional int32 capacity = 9;
   */
  capacity?: number;

  /**
   * @generated from field: repeated api.v1.event.Image images = 10;
   */
  images: Image[];

  /**
   * @generated from field: api.v1.event.EventStatus status = 11;
   */
  status: EventStatus;

  /**
   * @generated from field: repeated string tags = 12;
   */
  tags: string[];

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 13;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 14;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: string timezone = 15;
   */
  timezone: string;

  /**
   * @generated from field: string venue_name = 16;
   */
  venueName: string;

  /**
   * @generated from field: string address = 17;
   */
  address: string;

  /**
   * @generated from field: string city = 18;
   */
  city: string;

  /**
   * @generated from field: string state = 19;
   */
  state: string;

  /**
   * @generated from field: string postal_code = 20;
   */
  postalCode: string;

  /**
   * @generated from field: string country = 21;
   */
  country: string;

  /**
   * @generated from field: double latitude = 22;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 23;
   */
  longitude: number;

  /**
   * Event FAQs
   *
   * @generated from field: repeated api.v1.event.FAQ faq_content = 24;
   */
  faqContent: FAQ[];

  /**
   * Event collaborators
   *
   * @generated from field: repeated api.v1.event.EventCollaboratorInput collaborators = 25;
   */
  collaborators: EventCollaboratorInput[];

  /**
   * External ticketing fields (verified organizations only)
   *
   * @generated from field: optional string external_ticket_url = 26;
   */
  externalTicketUrl?: string;

  /**
   * @generated from field: api.v1.event.EventVisibility visibility = 27;
   */
  visibility: EventVisibility;

  /**
   * optional string external_ticket_provider = 28; // e.g., "Ticketmaster", "Eventbrite"
   *
   * Tiptap JSONContent for rich text
   *
   * @generated from field: optional string description_rich = 29;
   */
  descriptionRich?: string;
};

/**
 * Describes the message api.v1.event.CreateEventRequest.
 * Use `create(CreateEventRequestSchema)` to create a new message.
 */
export const CreateEventRequestSchema: GenMessage<CreateEventRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 1);

/**
 * CollaboratorFailure represents a failed collaborator addition
 *
 * @generated from message api.v1.event.CollaboratorFailure
 */
export type CollaboratorFailure = Message<"api.v1.event.CollaboratorFailure"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: api.v1.event.EventCollaboratorEntityType entity_type = 2;
   */
  entityType: EventCollaboratorEntityType;

  /**
   * @generated from field: api.v1.event.EventCollaborationType collaboration_type = 3;
   */
  collaborationType: EventCollaborationType;

  /**
   * @generated from field: string error = 4;
   */
  error: string;

  /**
   * @generated from field: string user_message = 5;
   */
  userMessage: string;

  /**
   * @generated from field: bool retryable = 6;
   */
  retryable: boolean;
};

/**
 * Describes the message api.v1.event.CollaboratorFailure.
 * Use `create(CollaboratorFailureSchema)` to create a new message.
 */
export const CollaboratorFailureSchema: GenMessage<CollaboratorFailure> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 2);

/**
 * CreateEventResponse is the response to create an event
 *
 * @generated from message api.v1.event.CreateEventResponse
 */
export type CreateEventResponse = Message<"api.v1.event.CreateEventResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: repeated api.v1.event.CollaboratorFailure collaborator_failures = 3;
   */
  collaboratorFailures: CollaboratorFailure[];
};

/**
 * Describes the message api.v1.event.CreateEventResponse.
 * Use `create(CreateEventResponseSchema)` to create a new message.
 */
export const CreateEventResponseSchema: GenMessage<CreateEventResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 3);

/**
 * GetEventRequest is the request to get an event
 *
 * @generated from message api.v1.event.GetEventRequest
 */
export type GetEventRequest = Message<"api.v1.event.GetEventRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Include all collaborators (including pending) for admin interfaces
   *
   * @generated from field: optional bool include_all_collaborators = 2;
   */
  includeAllCollaborators?: boolean;
};

/**
 * Describes the message api.v1.event.GetEventRequest.
 * Use `create(GetEventRequestSchema)` to create a new message.
 */
export const GetEventRequestSchema: GenMessage<GetEventRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 4);

/**
 * UpdateEventRequest is the request to update an event
 *
 * @generated from message api.v1.event.UpdateEventRequest
 */
export type UpdateEventRequest = Message<"api.v1.event.UpdateEventRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: api.v1.event.EventType event_type = 4;
   */
  eventType: EventType;

  /**
   * @generated from field: optional string ticket_url = 5;
   */
  ticketUrl?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp registration_deadline = 6;
   */
  registrationDeadline?: Timestamp;

  /**
   * @generated from field: optional google.type.Money price = 7;
   */
  price?: Money;

  /**
   * @generated from field: optional int32 capacity = 8;
   */
  capacity?: number;

  /**
   * @generated from field: repeated api.v1.event.Image images = 9;
   */
  images: Image[];

  /**
   * @generated from field: api.v1.event.EventStatus status = 10;
   */
  status: EventStatus;

  /**
   * @generated from field: repeated string tags = 11;
   */
  tags: string[];

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 12;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 13;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: string venue_name = 14;
   */
  venueName: string;

  /**
   * @generated from field: string address = 15;
   */
  address: string;

  /**
   * @generated from field: string city = 16;
   */
  city: string;

  /**
   * @generated from field: string state = 17;
   */
  state: string;

  /**
   * @generated from field: string postal_code = 18;
   */
  postalCode: string;

  /**
   * @generated from field: string country = 19;
   */
  country: string;

  /**
   * @generated from field: double latitude = 20;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 21;
   */
  longitude: number;

  /**
   * @generated from field: string timezone = 22;
   */
  timezone: string;

  /**
   * Event FAQs
   *
   * @generated from field: repeated api.v1.event.FAQ faq_content = 23;
   */
  faqContent: FAQ[];

  /**
   * Event collaborators
   *
   * @generated from field: repeated api.v1.event.EventCollaboratorInput collaborators = 24;
   */
  collaborators: EventCollaboratorInput[];

  /**
   * External ticketing fields (verified organizations only)
   *
   * @generated from field: optional string external_ticket_url = 25;
   */
  externalTicketUrl?: string;

  /**
   * @generated from field: api.v1.event.EventVisibility visibility = 26;
   */
  visibility: EventVisibility;

  /**
   * optional string external_ticket_provider = 27; // e.g., "Ticketmaster", "Eventbrite"
   *
   * Tiptap JSONContent for rich text
   *
   * @generated from field: optional string description_rich = 28;
   */
  descriptionRich?: string;
};

/**
 * Describes the message api.v1.event.UpdateEventRequest.
 * Use `create(UpdateEventRequestSchema)` to create a new message.
 */
export const UpdateEventRequestSchema: GenMessage<UpdateEventRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 5);

/**
 * DeleteEventRequest is the request to delete an event
 *
 * @generated from message api.v1.event.DeleteEventRequest
 */
export type DeleteEventRequest = Message<"api.v1.event.DeleteEventRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.event.DeleteEventRequest.
 * Use `create(DeleteEventRequestSchema)` to create a new message.
 */
export const DeleteEventRequestSchema: GenMessage<DeleteEventRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 6);

/**
 * Community search parameters
 *
 * @generated from message api.v1.event.CommunitySearchParams
 */
export type CommunitySearchParams = Message<"api.v1.event.CommunitySearchParams"> & {
  /**
   * @generated from field: google.type.LatLng center_location = 1;
   */
  centerLocation?: LatLng;

  /**
   * @generated from field: int32 radius_km = 2;
   */
  radiusKm: number;
};

/**
 * Describes the message api.v1.event.CommunitySearchParams.
 * Use `create(CommunitySearchParamsSchema)` to create a new message.
 */
export const CommunitySearchParamsSchema: GenMessage<CommunitySearchParams> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 7);

/**
 * Beyond search parameters  
 *
 * Empty for now - could add global filters later like:
 * repeated string country_codes = 1;
 * repeated string region_codes = 2;
 *
 * @generated from message api.v1.event.BeyondSearchParams
 */
export type BeyondSearchParams = Message<"api.v1.event.BeyondSearchParams"> & {
};

/**
 * Describes the message api.v1.event.BeyondSearchParams.
 * Use `create(BeyondSearchParamsSchema)` to create a new message.
 */
export const BeyondSearchParamsSchema: GenMessage<BeyondSearchParams> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 8);

/**
 * Unified SearchEventsRequest replacing all search/list variants
 *
 * @generated from message api.v1.event.SearchEventsRequest
 */
export type SearchEventsRequest = Message<"api.v1.event.SearchEventsRequest"> & {
  /**
   * Location search mode (required - exactly one)
   *
   * @generated from oneof api.v1.event.SearchEventsRequest.location_search
   */
  locationSearch: {
    /**
     * @generated from field: api.v1.event.CommunitySearchParams community = 1;
     */
    value: CommunitySearchParams;
    case: "community";
  } | {
    /**
     * @generated from field: api.v1.event.BeyondSearchParams beyond = 2;
     */
    value: BeyondSearchParams;
    case: "beyond";
  } | { case: undefined; value?: undefined };

  /**
   * Search filters (same for both modes)
   *
   * @generated from field: optional string search_query = 3;
   */
  searchQuery?: string;

  /**
   * @generated from field: repeated api.v1.event.EventType event_types = 4;
   */
  eventTypes: EventType[];

  /**
   * @generated from field: repeated api.v1.event.EventStatus statuses = 5;
   */
  statuses: EventStatus[];

  /**
   * @generated from field: repeated string category_ids = 6;
   */
  categoryIds: string[];

  /**
   * @generated from field: repeated string tag_names = 7;
   */
  tagNames: string[];

  /**
   * Date range filters
   *
   * @generated from field: optional google.protobuf.Timestamp start_date_after = 8;
   */
  startDateAfter?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp start_date_before = 9;
   */
  startDateBefore?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_date_after = 10;
   */
  endDateAfter?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_date_before = 11;
   */
  endDateBefore?: Timestamp;

  /**
   * Price filters
   *
   * @generated from field: optional double min_price = 12;
   */
  minPrice?: number;

  /**
   * @generated from field: optional double max_price = 13;
   */
  maxPrice?: number;

  /**
   * Capacity filters
   *
   * @generated from field: optional int32 min_capacity = 14;
   */
  minCapacity?: number;

  /**
   * @generated from field: optional int32 max_capacity = 15;
   */
  maxCapacity?: number;

  /**
   * Options
   *
   * Include events without physical location
   *
   * @generated from field: bool include_virtual_events = 16;
   */
  includeVirtualEvents: boolean;

  /**
   * Include events at capacity
   *
   * @generated from field: bool include_full_events = 17;
   */
  includeFullEvents: boolean;

  /**
   * Filter by specific organization
   *
   * @generated from field: optional string org_id = 18;
   */
  orgId?: string;

  /**
   * Sorting and pagination
   *
   * @generated from field: api.v1.event.SearchSortBy sort_by = 19;
   */
  sortBy: SearchSortBy;

  /**
   * @generated from field: bool sort_descending = 20;
   */
  sortDescending: boolean;

  /**
   * @generated from field: api.v1.common.PaginationRequest pagination = 21;
   */
  pagination?: PaginationRequest;

  /**
   * Visibility filters
   *
   * @generated from field: repeated api.v1.event.EventVisibility visibilities = 22;
   */
  visibilities: EventVisibility[];
};

/**
 * Describes the message api.v1.event.SearchEventsRequest.
 * Use `create(SearchEventsRequestSchema)` to create a new message.
 */
export const SearchEventsRequestSchema: GenMessage<SearchEventsRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 9);

/**
 * Event result with optional distance info for community searches
 *
 * @generated from message api.v1.event.EventSearchResult
 */
export type EventSearchResult = Message<"api.v1.event.EventSearchResult"> & {
  /**
   * @generated from field: api.v1.event.Event event = 1;
   */
  event?: Event;

  /**
   * Only populated for COMMUNITY mode
   *
   * @generated from field: optional api.v1.event.DistanceInfo distance_info = 2;
   */
  distanceInfo?: DistanceInfo;

  /**
   * @generated from field: bool is_in_user_preferred_area = 3;
   */
  isInUserPreferredArea: boolean;
};

/**
 * Describes the message api.v1.event.EventSearchResult.
 * Use `create(EventSearchResultSchema)` to create a new message.
 */
export const EventSearchResultSchema: GenMessage<EventSearchResult> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 10);

/**
 * Unified SearchEventsResponse
 *
 * @generated from message api.v1.event.SearchEventsResponse
 */
export type SearchEventsResponse = Message<"api.v1.event.SearchEventsResponse"> & {
  /**
   * @generated from field: repeated api.v1.event.EventSearchResult events = 1;
   */
  events: EventSearchResult[];

  /**
   * @generated from field: api.v1.common.Pagination pagination = 2;
   */
  pagination?: Pagination;

  /**
   * Search context
   *
   * Only for COMMUNITY mode
   *
   * @generated from field: optional google.type.LatLng search_center = 3;
   */
  searchCenter?: LatLng;

  /**
   * Only for COMMUNITY mode
   *
   * @generated from field: optional int32 search_radius_km = 4;
   */
  searchRadiusKm?: number;
};

/**
 * Describes the message api.v1.event.SearchEventsResponse.
 * Use `create(SearchEventsResponseSchema)` to create a new message.
 */
export const SearchEventsResponseSchema: GenMessage<SearchEventsResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 11);

/**
 * GenerateEventIdRequest is the request to generate a new event ID
 *
 * Empty request - no parameters needed
 *
 * @generated from message api.v1.event.GenerateEventIdRequest
 */
export type GenerateEventIdRequest = Message<"api.v1.event.GenerateEventIdRequest"> & {
};

/**
 * Describes the message api.v1.event.GenerateEventIdRequest.
 * Use `create(GenerateEventIdRequestSchema)` to create a new message.
 */
export const GenerateEventIdRequestSchema: GenMessage<GenerateEventIdRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 12);

/**
 * GenerateEventIdResponse is the response containing the generated event ID
 *
 * @generated from message api.v1.event.GenerateEventIdResponse
 */
export type GenerateEventIdResponse = Message<"api.v1.event.GenerateEventIdResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.event.GenerateEventIdResponse.
 * Use `create(GenerateEventIdResponseSchema)` to create a new message.
 */
export const GenerateEventIdResponseSchema: GenMessage<GenerateEventIdResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 13);

/**
 * CreateImageRequest is the request to create an image
 *
 * @generated from message api.v1.event.CreateImageRequest
 */
export type CreateImageRequest = Message<"api.v1.event.CreateImageRequest"> & {
  /**
   * @generated from field: api.v1.image.Image image = 1;
   */
  image?: Image$1;
};

/**
 * Describes the message api.v1.event.CreateImageRequest.
 * Use `create(CreateImageRequestSchema)` to create a new message.
 */
export const CreateImageRequestSchema: GenMessage<CreateImageRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 14);

/**
 * IsSavedEventRequest is the request to check if an event is saved
 *
 * @generated from message api.v1.event.IsSavedEventRequest
 */
export type IsSavedEventRequest = Message<"api.v1.event.IsSavedEventRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.event.IsSavedEventRequest.
 * Use `create(IsSavedEventRequestSchema)` to create a new message.
 */
export const IsSavedEventRequestSchema: GenMessage<IsSavedEventRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 15);

/**
 * IsSavedEventResponse is the response to check if an event is saved
 *
 * @generated from message api.v1.event.IsSavedEventResponse
 */
export type IsSavedEventResponse = Message<"api.v1.event.IsSavedEventResponse"> & {
  /**
   * @generated from field: bool is_saved = 1;
   */
  isSaved: boolean;
};

/**
 * Describes the message api.v1.event.IsSavedEventResponse.
 * Use `create(IsSavedEventResponseSchema)` to create a new message.
 */
export const IsSavedEventResponseSchema: GenMessage<IsSavedEventResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 16);

/**
 * RegisterEventRequest is the request to register for an event
 *
 * @generated from message api.v1.event.RegisterEventRequest
 */
export type RegisterEventRequest = Message<"api.v1.event.RegisterEventRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: optional string first_name = 3;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 4;
   */
  lastName?: string;
};

/**
 * Describes the message api.v1.event.RegisterEventRequest.
 * Use `create(RegisterEventRequestSchema)` to create a new message.
 */
export const RegisterEventRequestSchema: GenMessage<RegisterEventRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 17);

/**
 * @generated from message api.v1.event.RegisterEventResponse
 */
export type RegisterEventResponse = Message<"api.v1.event.RegisterEventResponse"> & {
  /**
   * @generated from field: optional string qr_code_image_url = 1;
   */
  qrCodeImageUrl?: string;
};

/**
 * Describes the message api.v1.event.RegisterEventResponse.
 * Use `create(RegisterEventResponseSchema)` to create a new message.
 */
export const RegisterEventResponseSchema: GenMessage<RegisterEventResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 18);

/**
 * CancelRegistrationRequest is the request to cancel a registration
 *
 * @generated from message api.v1.event.CancelRegistrationRequest
 */
export type CancelRegistrationRequest = Message<"api.v1.event.CancelRegistrationRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message api.v1.event.CancelRegistrationRequest.
 * Use `create(CancelRegistrationRequestSchema)` to create a new message.
 */
export const CancelRegistrationRequestSchema: GenMessage<CancelRegistrationRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 19);

/**
 * GetRegistrationStatusRequest is the request to get registration status
 *
 * @generated from message api.v1.event.GetRegistrationStatusRequest
 */
export type GetRegistrationStatusRequest = Message<"api.v1.event.GetRegistrationStatusRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message api.v1.event.GetRegistrationStatusRequest.
 * Use `create(GetRegistrationStatusRequestSchema)` to create a new message.
 */
export const GetRegistrationStatusRequestSchema: GenMessage<GetRegistrationStatusRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 20);

/**
 * GetRegistrationStatusResponse is the response containing registration status
 *
 * @generated from message api.v1.event.GetRegistrationStatusResponse
 */
export type GetRegistrationStatusResponse = Message<"api.v1.event.GetRegistrationStatusResponse"> & {
  /**
   * @generated from field: api.v1.event.RegistrationStatus status = 1;
   */
  status: RegistrationStatus;

  /**
   * @generated from field: optional google.protobuf.Timestamp registration_date = 2;
   */
  registrationDate?: Timestamp;

  /**
   * true if registered and eligible for QR code
   *
   * @generated from field: bool can_get_qr_code = 3;
   */
  canGetQrCode: boolean;

  /**
   * @generated from field: optional string ticket_id = 4;
   */
  ticketId?: string;
};

/**
 * Describes the message api.v1.event.GetRegistrationStatusResponse.
 * Use `create(GetRegistrationStatusResponseSchema)` to create a new message.
 */
export const GetRegistrationStatusResponseSchema: GenMessage<GetRegistrationStatusResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 21);

/**
 * GetAttendeeQRCodeRequest is the request to get/generate QR code for check-in
 *
 * @generated from message api.v1.event.GetAttendeeQRCodeRequest
 */
export type GetAttendeeQRCodeRequest = Message<"api.v1.event.GetAttendeeQRCodeRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message api.v1.event.GetAttendeeQRCodeRequest.
 * Use `create(GetAttendeeQRCodeRequestSchema)` to create a new message.
 */
export const GetAttendeeQRCodeRequestSchema: GenMessage<GetAttendeeQRCodeRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 22);

/**
 * GetAttendeeQRCodeResponse is the response containing QR code information
 *
 * @generated from message api.v1.event.GetAttendeeQRCodeResponse
 */
export type GetAttendeeQRCodeResponse = Message<"api.v1.event.GetAttendeeQRCodeResponse"> & {
  /**
   * @generated from field: string qr_code_url = 1;
   */
  qrCodeUrl: string;

  /**
   * @generated from field: string token = 2;
   */
  token: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: bool already_checked_in = 4;
   */
  alreadyCheckedIn: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp checked_in_at = 5;
   */
  checkedInAt?: Timestamp;
};

/**
 * Describes the message api.v1.event.GetAttendeeQRCodeResponse.
 * Use `create(GetAttendeeQRCodeResponseSchema)` to create a new message.
 */
export const GetAttendeeQRCodeResponseSchema: GenMessage<GetAttendeeQRCodeResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 23);

/**
 * CheckInAttendeeRequest is the request to check in an attendee via QR code
 *
 * @generated from message api.v1.event.CheckInAttendeeRequest
 */
export type CheckInAttendeeRequest = Message<"api.v1.event.CheckInAttendeeRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string event_id = 2;
   */
  eventId: string;

  /**
   * @generated from field: api.v1.event.CheckInMethod check_in_method = 3;
   */
  checkInMethod: CheckInMethod;
};

/**
 * Describes the message api.v1.event.CheckInAttendeeRequest.
 * Use `create(CheckInAttendeeRequestSchema)` to create a new message.
 */
export const CheckInAttendeeRequestSchema: GenMessage<CheckInAttendeeRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 24);

/**
 * CheckInAttendeeResponse is the response for check-in attempt
 *
 * @generated from message api.v1.event.CheckInAttendeeResponse
 */
export type CheckInAttendeeResponse = Message<"api.v1.event.CheckInAttendeeResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: optional string error = 2;
   */
  error?: string;

  /**
   * @generated from field: optional api.v1.event.EventAttendee attendee = 3;
   */
  attendee?: EventAttendee;

  /**
   * @generated from field: optional api.v1.event.Event event = 4;
   */
  event?: Event;
};

/**
 * Describes the message api.v1.event.CheckInAttendeeResponse.
 * Use `create(CheckInAttendeeResponseSchema)` to create a new message.
 */
export const CheckInAttendeeResponseSchema: GenMessage<CheckInAttendeeResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 25);

/**
 * GetEventAttendanceRequest is the request to get real-time attendance stats
 *
 * @generated from message api.v1.event.GetEventAttendanceRequest
 */
export type GetEventAttendanceRequest = Message<"api.v1.event.GetEventAttendanceRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message api.v1.event.GetEventAttendanceRequest.
 * Use `create(GetEventAttendanceRequestSchema)` to create a new message.
 */
export const GetEventAttendanceRequestSchema: GenMessage<GetEventAttendanceRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 26);

/**
 * GetEventAttendanceResponse is the response with attendance statistics
 *
 * @generated from message api.v1.event.GetEventAttendanceResponse
 */
export type GetEventAttendanceResponse = Message<"api.v1.event.GetEventAttendanceResponse"> & {
  /**
   * @generated from field: int32 total_registrations = 1;
   */
  totalRegistrations: number;

  /**
   * @generated from field: int32 checked_in_count = 2;
   */
  checkedInCount: number;

  /**
   * @generated from field: int32 not_checked_in_count = 3;
   */
  notCheckedInCount: number;

  /**
   * @generated from field: double attendance_rate = 4;
   */
  attendanceRate: number;

  /**
   * @generated from field: repeated api.v1.event.RecentCheckIn recent_check_ins = 5;
   */
  recentCheckIns: RecentCheckIn[];

  /**
   * @generated from field: repeated api.v1.event.AttendanceTimePoint timeline = 6;
   */
  timeline: AttendanceTimePoint[];
};

/**
 * Describes the message api.v1.event.GetEventAttendanceResponse.
 * Use `create(GetEventAttendanceResponseSchema)` to create a new message.
 */
export const GetEventAttendanceResponseSchema: GenMessage<GetEventAttendanceResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 27);

/**
 * ListAttendeesRequest is the request to list event attendees
 *
 * @generated from message api.v1.event.ListAttendeesRequest
 */
export type ListAttendeesRequest = Message<"api.v1.event.ListAttendeesRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: optional api.v1.common.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest;

  /**
   * Filters
   *
   * @generated from field: optional bool checked_in_only = 3;
   */
  checkedInOnly?: boolean;

  /**
   * @generated from field: optional bool not_checked_in_only = 4;
   */
  notCheckedInOnly?: boolean;

  /**
   * search by name or email
   *
   * @generated from field: optional string search_query = 5;
   */
  searchQuery?: string;

  /**
   * @generated from field: optional api.v1.event.ListAttendeesRequest.SortField sort_by = 6;
   */
  sortBy?: ListAttendeesRequest_SortField;

  /**
   * @generated from field: optional bool sort_descending = 7;
   */
  sortDescending?: boolean;
};

/**
 * Describes the message api.v1.event.ListAttendeesRequest.
 * Use `create(ListAttendeesRequestSchema)` to create a new message.
 */
export const ListAttendeesRequestSchema: GenMessage<ListAttendeesRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 28);

/**
 * Sorting
 *
 * @generated from enum api.v1.event.ListAttendeesRequest.SortField
 */
export enum ListAttendeesRequest_SortField {
  /**
   * @generated from enum value: SORT_FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SORT_FIELD_NAME = 1;
   */
  NAME = 1,

  /**
   * @generated from enum value: SORT_FIELD_EMAIL = 2;
   */
  EMAIL = 2,

  /**
   * @generated from enum value: SORT_FIELD_CREATED_AT = 3;
   */
  CREATED_AT = 3,

  /**
   * @generated from enum value: SORT_FIELD_CHECKED_IN_AT = 4;
   */
  CHECKED_IN_AT = 4,
}

/**
 * Describes the enum api.v1.event.ListAttendeesRequest.SortField.
 */
export const ListAttendeesRequest_SortFieldSchema: GenEnum<ListAttendeesRequest_SortField> = /*@__PURE__*/
  enumDesc(file_v1_event_event_requests, 28, 0);

/**
 * ListAttendeesResponse is the response containing attendees list
 *
 * @generated from message api.v1.event.ListAttendeesResponse
 */
export type ListAttendeesResponse = Message<"api.v1.event.ListAttendeesResponse"> & {
  /**
   * @generated from field: repeated api.v1.event.EventAttendee attendees = 1;
   */
  attendees: EventAttendee[];

  /**
   * @generated from field: optional api.v1.common.Pagination pagination = 2;
   */
  pagination?: Pagination;

  /**
   * Summary stats
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;

  /**
   * @generated from field: int32 checked_in_count = 4;
   */
  checkedInCount: number;

  /**
   * @generated from field: int32 not_checked_in_count = 5;
   */
  notCheckedInCount: number;
};

/**
 * Describes the message api.v1.event.ListAttendeesResponse.
 * Use `create(ListAttendeesResponseSchema)` to create a new message.
 */
export const ListAttendeesResponseSchema: GenMessage<ListAttendeesResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 29);

/**
 * AddCollaboratorRequest is the request to add a collaborator to an event
 *
 * @generated from message api.v1.event.AddCollaboratorRequest
 */
export type AddCollaboratorRequest = Message<"api.v1.event.AddCollaboratorRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: api.v1.event.EventCollaboratorEntityType entity_type = 2;
   */
  entityType: EventCollaboratorEntityType;

  /**
   * user_id or org_id
   *
   * @generated from field: string entity_id = 3;
   */
  entityId: string;

  /**
   * @generated from field: api.v1.event.EventCollaborationType collaboration_type = 4;
   */
  collaborationType: EventCollaborationType;

  /**
   * @generated from field: api.v1.event.EventCollaboratorRequesterStatus requester_status = 5;
   */
  requesterStatus: EventCollaboratorRequesterStatus;
};

/**
 * Describes the message api.v1.event.AddCollaboratorRequest.
 * Use `create(AddCollaboratorRequestSchema)` to create a new message.
 */
export const AddCollaboratorRequestSchema: GenMessage<AddCollaboratorRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 30);

/**
 * AddCollaboratorResponse is the response to add a collaborator
 *
 * @generated from message api.v1.event.AddCollaboratorResponse
 */
export type AddCollaboratorResponse = Message<"api.v1.event.AddCollaboratorResponse"> & {
  /**
   * The created collaborator record ID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.event.AddCollaboratorResponse.
 * Use `create(AddCollaboratorResponseSchema)` to create a new message.
 */
export const AddCollaboratorResponseSchema: GenMessage<AddCollaboratorResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 31);

/**
 * GetCollaboratorRequest is the request to get a collaborator
 *
 * @generated from message api.v1.event.GetCollaboratorRequest
 */
export type GetCollaboratorRequest = Message<"api.v1.event.GetCollaboratorRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api.v1.event.GetCollaboratorRequest.
 * Use `create(GetCollaboratorRequestSchema)` to create a new message.
 */
export const GetCollaboratorRequestSchema: GenMessage<GetCollaboratorRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 32);

/**
 * GetCollaboratorResponse is the response to get a collaborator
 *
 * @generated from message api.v1.event.GetCollaboratorResponse
 */
export type GetCollaboratorResponse = Message<"api.v1.event.GetCollaboratorResponse"> & {
  /**
   * @generated from field: api.v1.event.EventCollaborator collaborator = 1;
   */
  collaborator?: EventCollaborator;
};

/**
 * Describes the message api.v1.event.GetCollaboratorResponse.
 * Use `create(GetCollaboratorResponseSchema)` to create a new message.
 */
export const GetCollaboratorResponseSchema: GenMessage<GetCollaboratorResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 33);

/**
 * ListCollaborationsByEntityRequest is the request to list collaborators by entity
 *
 * @generated from message api.v1.event.ListCollaborationsByEntityRequest
 */
export type ListCollaborationsByEntityRequest = Message<"api.v1.event.ListCollaborationsByEntityRequest"> & {
  /**
   * "user" or "org"
   *
   * @generated from field: api.v1.event.EventCollaboratorEntityType entity_type = 1;
   */
  entityType: EventCollaboratorEntityType;

  /**
   * user_id or org_id
   *
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: optional api.v1.common.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequest;

  /**
   * Include past events
   *
   * @generated from field: optional bool include_past_events = 4;
   */
  includePastEvents?: boolean;
};

/**
 * Describes the message api.v1.event.ListCollaborationsByEntityRequest.
 * Use `create(ListCollaborationsByEntityRequestSchema)` to create a new message.
 */
export const ListCollaborationsByEntityRequestSchema: GenMessage<ListCollaborationsByEntityRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 34);

/**
 * ListCollaborationsByEntityResponse is the response containing collaborator events
 *
 * @generated from message api.v1.event.ListCollaborationsByEntityResponse
 */
export type ListCollaborationsByEntityResponse = Message<"api.v1.event.ListCollaborationsByEntityResponse"> & {
  /**
   * @generated from field: repeated api.v1.event.ListCollaborationsByEntityResponse.EventWithCollaborator events_with_collaborator = 1;
   */
  eventsWithCollaborator: ListCollaborationsByEntityResponse_EventWithCollaborator[];

  /**
   * @generated from field: optional api.v1.common.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message api.v1.event.ListCollaborationsByEntityResponse.
 * Use `create(ListCollaborationsByEntityResponseSchema)` to create a new message.
 */
export const ListCollaborationsByEntityResponseSchema: GenMessage<ListCollaborationsByEntityResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 35);

/**
 * @generated from message api.v1.event.ListCollaborationsByEntityResponse.EventWithCollaborator
 */
export type ListCollaborationsByEntityResponse_EventWithCollaborator = Message<"api.v1.event.ListCollaborationsByEntityResponse.EventWithCollaborator"> & {
  /**
   * @generated from field: api.v1.event.Event event = 1;
   */
  event?: Event;

  /**
   * @generated from field: api.v1.event.EventCollaborator collaborator = 2;
   */
  collaborator?: EventCollaborator;
};

/**
 * Describes the message api.v1.event.ListCollaborationsByEntityResponse.EventWithCollaborator.
 * Use `create(ListCollaborationsByEntityResponse_EventWithCollaboratorSchema)` to create a new message.
 */
export const ListCollaborationsByEntityResponse_EventWithCollaboratorSchema: GenMessage<ListCollaborationsByEntityResponse_EventWithCollaborator> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 35, 0);

/**
 * ListEventCollaboratorsRequest is the request to list collaborators for an event
 *
 * @generated from message api.v1.event.ListEventCollaboratorsRequest
 */
export type ListEventCollaboratorsRequest = Message<"api.v1.event.ListEventCollaboratorsRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: optional api.v1.common.PaginationRequest pagination = 2;
   */
  pagination?: PaginationRequest;

  /**
   * Filter by type
   *
   * @generated from field: optional api.v1.event.EventCollaborationType type_filter = 3;
   */
  typeFilter?: EventCollaborationType;

  /**
   * Include all collaborators (including pending) for admin interfaces
   *
   * @generated from field: optional bool include_all_collaborators = 4;
   */
  includeAllCollaborators?: boolean;
};

/**
 * Describes the message api.v1.event.ListEventCollaboratorsRequest.
 * Use `create(ListEventCollaboratorsRequestSchema)` to create a new message.
 */
export const ListEventCollaboratorsRequestSchema: GenMessage<ListEventCollaboratorsRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 36);

/**
 * ListEventCollaboratorsResponse is the response containing event collaborators
 *
 * @generated from message api.v1.event.ListEventCollaboratorsResponse
 */
export type ListEventCollaboratorsResponse = Message<"api.v1.event.ListEventCollaboratorsResponse"> & {
  /**
   * @generated from field: repeated api.v1.event.EventCollaborator collaborators = 1;
   */
  collaborators: EventCollaborator[];

  /**
   * @generated from field: optional api.v1.common.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message api.v1.event.ListEventCollaboratorsResponse.
 * Use `create(ListEventCollaboratorsResponseSchema)` to create a new message.
 */
export const ListEventCollaboratorsResponseSchema: GenMessage<ListEventCollaboratorsResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 37);

/**
 * ListPendingCollaborationsRequest is the request to list pending collaborations
 *
 * @generated from message api.v1.event.ListPendingCollaborationsRequest
 */
export type ListPendingCollaborationsRequest = Message<"api.v1.event.ListPendingCollaborationsRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: api.v1.event.EventCollaboratorEntityType entity_type = 2;
   */
  entityType: EventCollaboratorEntityType;

  /**
   * @generated from field: string entity_id = 3;
   */
  entityId: string;
};

/**
 * Describes the message api.v1.event.ListPendingCollaborationsRequest.
 * Use `create(ListPendingCollaborationsRequestSchema)` to create a new message.
 */
export const ListPendingCollaborationsRequestSchema: GenMessage<ListPendingCollaborationsRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 38);

/**
 * ListPendingCollaborationsResponse is the response to list pending collaborations
 *
 * @generated from message api.v1.event.ListPendingCollaborationsResponse
 */
export type ListPendingCollaborationsResponse = Message<"api.v1.event.ListPendingCollaborationsResponse"> & {
  /**
   * @generated from field: repeated api.v1.event.EventCollaborator collaborators = 1;
   */
  collaborators: EventCollaborator[];
};

/**
 * Describes the message api.v1.event.ListPendingCollaborationsResponse.
 * Use `create(ListPendingCollaborationsResponseSchema)` to create a new message.
 */
export const ListPendingCollaborationsResponseSchema: GenMessage<ListPendingCollaborationsResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 39);

/**
 * RemoveCollaboratorRequest is the request to remove a collaborator from an event
 *
 * @generated from message api.v1.event.RemoveCollaboratorRequest
 */
export type RemoveCollaboratorRequest = Message<"api.v1.event.RemoveCollaboratorRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message api.v1.event.RemoveCollaboratorRequest.
 * Use `create(RemoveCollaboratorRequestSchema)` to create a new message.
 */
export const RemoveCollaboratorRequestSchema: GenMessage<RemoveCollaboratorRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 40);

/**
 * SearchUsersAndOrgsRequest is the request to search for users and organizations
 *
 * @generated from message api.v1.event.SearchUsersAndOrgsRequest
 */
export type SearchUsersAndOrgsRequest = Message<"api.v1.event.SearchUsersAndOrgsRequest"> & {
  /**
   * Search query (name, username, etc.)
   *
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * IDs to exclude from results
   *
   * @generated from field: repeated string exclude_orgs = 2;
   */
  excludeOrgs: string[];

  /**
   * IDs to exclude from results
   *
   * @generated from field: repeated string exclude_users = 3;
   */
  excludeUsers: string[];

  /**
   * Maximum number of results (default: 10)
   *
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;

  /**
   * Filter by type
   *
   * @generated from field: optional api.v1.event.EventCollaborationType type_filter = 5;
   */
  typeFilter?: EventCollaborationType;
};

/**
 * Describes the message api.v1.event.SearchUsersAndOrgsRequest.
 * Use `create(SearchUsersAndOrgsRequestSchema)` to create a new message.
 */
export const SearchUsersAndOrgsRequestSchema: GenMessage<SearchUsersAndOrgsRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 41);

/**
 * SearchUsersAndOrgsResponse is the response containing search results
 *
 * @generated from message api.v1.event.SearchUsersAndOrgsResponse
 */
export type SearchUsersAndOrgsResponse = Message<"api.v1.event.SearchUsersAndOrgsResponse"> & {
  /**
   * @generated from field: repeated api.v1.event.CollaboratorSearchResult results = 1;
   */
  results: CollaboratorSearchResult[];

  /**
   * Whether there are more results
   *
   * @generated from field: bool has_more = 2;
   */
  hasMore: boolean;
};

/**
 * Describes the message api.v1.event.SearchUsersAndOrgsResponse.
 * Use `create(SearchUsersAndOrgsResponseSchema)` to create a new message.
 */
export const SearchUsersAndOrgsResponseSchema: GenMessage<SearchUsersAndOrgsResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 42);

/**
 * UpdateCollaboratorRequest is the request to update a collaborator's status
 *
 * @generated from message api.v1.event.UpdateCollaboratorRequest
 */
export type UpdateCollaboratorRequest = Message<"api.v1.event.UpdateCollaboratorRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * The collaborator record ID
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: optional api.v1.event.EventCollaborationType collaboration_type = 3;
   */
  collaborationType?: EventCollaborationType;

  /**
   * @generated from oneof api.v1.event.UpdateCollaboratorRequest.status
   */
  status: {
    /**
     * @generated from field: api.v1.event.EventCollaboratorRequesterStatus requester_status = 4;
     */
    value: EventCollaboratorRequesterStatus;
    case: "requesterStatus";
  } | {
    /**
     * @generated from field: api.v1.event.UpdateCollaboratorRequest.RequesteeStatusInfo requestee_status = 5;
     */
    value: UpdateCollaboratorRequest_RequesteeStatusInfo;
    case: "requesteeStatus";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message api.v1.event.UpdateCollaboratorRequest.
 * Use `create(UpdateCollaboratorRequestSchema)` to create a new message.
 */
export const UpdateCollaboratorRequestSchema: GenMessage<UpdateCollaboratorRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 43);

/**
 * @generated from message api.v1.event.UpdateCollaboratorRequest.RequesteeStatusInfo
 */
export type UpdateCollaboratorRequest_RequesteeStatusInfo = Message<"api.v1.event.UpdateCollaboratorRequest.RequesteeStatusInfo"> & {
  /**
   * @generated from field: api.v1.event.EventCollaboratorRequesteeStatus requestee_status = 1;
   */
  requesteeStatus: EventCollaboratorRequesteeStatus;

  /**
   * @generated from field: api.v1.event.EventCollaboratorDenialReason denial_reason = 2;
   */
  denialReason: EventCollaboratorDenialReason;

  /**
   * @generated from field: optional string denial_reason_other = 3;
   */
  denialReasonOther?: string;
};

/**
 * Describes the message api.v1.event.UpdateCollaboratorRequest.RequesteeStatusInfo.
 * Use `create(UpdateCollaboratorRequest_RequesteeStatusInfoSchema)` to create a new message.
 */
export const UpdateCollaboratorRequest_RequesteeStatusInfoSchema: GenMessage<UpdateCollaboratorRequest_RequesteeStatusInfo> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 43, 0);

/**
 * UpdateCollaboratorRequesteeStatusRequest is the request for requestees to update their own status
 *
 * @generated from message api.v1.event.UpdateCollaboratorRequesteeStatusRequest
 */
export type UpdateCollaboratorRequesteeStatusRequest = Message<"api.v1.event.UpdateCollaboratorRequesteeStatusRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * The collaborator record ID
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: api.v1.event.EventCollaboratorRequesteeStatus requestee_status = 3;
   */
  requesteeStatus: EventCollaboratorRequesteeStatus;

  /**
   * @generated from field: optional api.v1.event.EventCollaboratorDenialReason denial_reason = 4;
   */
  denialReason?: EventCollaboratorDenialReason;

  /**
   * @generated from field: optional string denial_reason_other = 5;
   */
  denialReasonOther?: string;
};

/**
 * Describes the message api.v1.event.UpdateCollaboratorRequesteeStatusRequest.
 * Use `create(UpdateCollaboratorRequesteeStatusRequestSchema)` to create a new message.
 */
export const UpdateCollaboratorRequesteeStatusRequestSchema: GenMessage<UpdateCollaboratorRequesteeStatusRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 44);

/**
 * GetUserRegisteredEventsRequest is the request to get all events a user has registered for
 *
 * @generated from message api.v1.event.GetUserRegisteredEventsRequest
 */
export type GetUserRegisteredEventsRequest = Message<"api.v1.event.GetUserRegisteredEventsRequest"> & {
  /**
   * @generated from field: optional api.v1.common.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * Filters
   *
   * Default: true (show all)
   *
   * @generated from field: optional bool include_past_events = 2;
   */
  includePastEvents?: boolean;

  /**
   * If true, only show upcoming events
   *
   * @generated from field: optional bool upcoming_only = 3;
   */
  upcomingOnly?: boolean;

  /**
   * Filter by registration status (registered, waitlisted, etc.)
   *
   * @generated from field: repeated api.v1.event.RegistrationStatus status_filter = 4;
   */
  statusFilter: RegistrationStatus[];

  /**
   * Search by event title, description, or org name
   *
   * @generated from field: optional string search_query = 5;
   */
  searchQuery?: string;

  /**
   * @generated from field: optional api.v1.event.GetUserRegisteredEventsRequest.SortField sort_by = 6;
   */
  sortBy?: GetUserRegisteredEventsRequest_SortField;

  /**
   * @generated from field: optional bool sort_descending = 7;
   */
  sortDescending?: boolean;
};

/**
 * Describes the message api.v1.event.GetUserRegisteredEventsRequest.
 * Use `create(GetUserRegisteredEventsRequestSchema)` to create a new message.
 */
export const GetUserRegisteredEventsRequestSchema: GenMessage<GetUserRegisteredEventsRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 45);

/**
 * Sorting
 *
 * @generated from enum api.v1.event.GetUserRegisteredEventsRequest.SortField
 */
export enum GetUserRegisteredEventsRequest_SortField {
  /**
   * @generated from enum value: SORT_FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * When user registered
   *
   * @generated from enum value: SORT_FIELD_REGISTRATION_DATE = 1;
   */
  REGISTRATION_DATE = 1,

  /**
   * Event start date
   *
   * @generated from enum value: SORT_FIELD_EVENT_START_DATE = 2;
   */
  EVENT_START_DATE = 2,

  /**
   * Alphabetical by title
   *
   * @generated from enum value: SORT_FIELD_EVENT_TITLE = 3;
   */
  EVENT_TITLE = 3,
}

/**
 * Describes the enum api.v1.event.GetUserRegisteredEventsRequest.SortField.
 */
export const GetUserRegisteredEventsRequest_SortFieldSchema: GenEnum<GetUserRegisteredEventsRequest_SortField> = /*@__PURE__*/
  enumDesc(file_v1_event_event_requests, 45, 0);

/**
 * UserRegisteredEvent represents an event with registration details
 *
 * @generated from message api.v1.event.UserRegisteredEvent
 */
export type UserRegisteredEvent = Message<"api.v1.event.UserRegisteredEvent"> & {
  /**
   * Full event details
   *
   * @generated from field: api.v1.event.Event event = 1;
   */
  event?: Event;

  /**
   * User's registration status
   *
   * @generated from field: api.v1.event.RegistrationStatus registration_status = 2;
   */
  registrationStatus: RegistrationStatus;

  /**
   * When user registered
   *
   * @generated from field: google.protobuf.Timestamp registration_date = 3;
   */
  registrationDate?: Timestamp;

  /**
   * QR code URL if available
   *
   * @generated from field: optional string qr_code_url = 4;
   */
  qrCodeUrl?: string;

  /**
   * Whether cancellation is allowed
   *
   * @generated from field: bool can_cancel = 5;
   */
  canCancel: boolean;

  /**
   * Ticket/attendee ID
   *
   * @generated from field: optional string ticket_id = 6;
   */
  ticketId?: string;
};

/**
 * Describes the message api.v1.event.UserRegisteredEvent.
 * Use `create(UserRegisteredEventSchema)` to create a new message.
 */
export const UserRegisteredEventSchema: GenMessage<UserRegisteredEvent> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 46);

/**
 * GetUserRegisteredEventsResponse is the response containing registered events
 *
 * @generated from message api.v1.event.GetUserRegisteredEventsResponse
 */
export type GetUserRegisteredEventsResponse = Message<"api.v1.event.GetUserRegisteredEventsResponse"> & {
  /**
   * @generated from field: repeated api.v1.event.UserRegisteredEvent registered_events = 1;
   */
  registeredEvents: UserRegisteredEvent[];

  /**
   * @generated from field: optional api.v1.common.Pagination pagination = 2;
   */
  pagination?: Pagination;

  /**
   * Summary counts
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;

  /**
   * @generated from field: int32 upcoming_count = 4;
   */
  upcomingCount: number;

  /**
   * @generated from field: int32 past_count = 5;
   */
  pastCount: number;
};

/**
 * Describes the message api.v1.event.GetUserRegisteredEventsResponse.
 * Use `create(GetUserRegisteredEventsResponseSchema)` to create a new message.
 */
export const GetUserRegisteredEventsResponseSchema: GenMessage<GetUserRegisteredEventsResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 47);

/**
 * DistanceInfo represents distance information between locations
 *
 * @generated from message api.v1.event.DistanceInfo
 */
export type DistanceInfo = Message<"api.v1.event.DistanceInfo"> & {
  /**
   * @generated from field: double distance_km = 1;
   */
  distanceKm: number;

  /**
   * @generated from field: double distance_miles = 2;
   */
  distanceMiles: number;

  /**
   * "2.3 miles" or "5.1 km"
   *
   * @generated from field: string formatted_distance = 3;
   */
  formattedDistance: string;
};

/**
 * Describes the message api.v1.event.DistanceInfo.
 * Use `create(DistanceInfoSchema)` to create a new message.
 */
export const DistanceInfoSchema: GenMessage<DistanceInfo> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 48);

/**
 * EventWithDistance represents an event with distance information
 *
 * @generated from message api.v1.event.EventWithDistance
 */
export type EventWithDistance = Message<"api.v1.event.EventWithDistance"> & {
  /**
   * @generated from field: api.v1.event.Event event = 1;
   */
  event?: Event;

  /**
   * @generated from field: api.v1.event.DistanceInfo distance_info = 2;
   */
  distanceInfo?: DistanceInfo;

  /**
   * @generated from field: bool is_in_user_preferred_area = 3;
   */
  isInUserPreferredArea: boolean;
};

/**
 * Describes the message api.v1.event.EventWithDistance.
 * Use `create(EventWithDistanceSchema)` to create a new message.
 */
export const EventWithDistanceSchema: GenMessage<EventWithDistance> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 49);

/**
 * GetNearbyEventsRequest is the request to get events near user's location
 *
 * @generated from message api.v1.event.GetNearbyEventsRequest
 */
export type GetNearbyEventsRequest = Message<"api.v1.event.GetNearbyEventsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * Override user's default preferences
   *
   * @generated from field: optional google.type.LatLng override_location = 2;
   */
  overrideLocation?: LatLng;

  /**
   * @generated from field: optional int32 override_radius_km = 3;
   */
  overrideRadiusKm?: number;

  /**
   * Quick filters
   *
   * Only show upcoming events (default: true)
   *
   * @generated from field: bool upcoming_only = 4;
   */
  upcomingOnly: boolean;

  /**
   * Only show events with available spots
   *
   * @generated from field: bool available_only = 5;
   */
  availableOnly: boolean;

  /**
   * Maximum number of results (default: 20)
   *
   * @generated from field: int32 limit = 6;
   */
  limit: number;

  /**
   * @generated from field: optional api.v1.event.GetNearbyEventsRequest.TimeRange time_range = 7;
   */
  timeRange?: GetNearbyEventsRequest_TimeRange;

  /**
   * Custom date range (only used if time_range = CUSTOM)
   *
   * @generated from field: optional google.protobuf.Timestamp custom_start_date = 8;
   */
  customStartDate?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp custom_end_date = 9;
   */
  customEndDate?: Timestamp;

  /**
   * Event type preferences
   *
   * @generated from field: repeated api.v1.event.EventType preferred_event_types = 10;
   */
  preferredEventTypes: EventType[];
};

/**
 * Describes the message api.v1.event.GetNearbyEventsRequest.
 * Use `create(GetNearbyEventsRequestSchema)` to create a new message.
 */
export const GetNearbyEventsRequestSchema: GenMessage<GetNearbyEventsRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 50);

/**
 * Time range (relative to current time)
 *
 * @generated from enum api.v1.event.GetNearbyEventsRequest.TimeRange
 */
export enum GetNearbyEventsRequest_TimeRange {
  /**
   * @generated from enum value: TIME_RANGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_RANGE_TODAY = 1;
   */
  TODAY = 1,

  /**
   * @generated from enum value: TIME_RANGE_THIS_WEEK = 2;
   */
  THIS_WEEK = 2,

  /**
   * @generated from enum value: TIME_RANGE_THIS_MONTH = 3;
   */
  THIS_MONTH = 3,

  /**
   * @generated from enum value: TIME_RANGE_NEXT_MONTH = 4;
   */
  NEXT_MONTH = 4,

  /**
   * @generated from enum value: TIME_RANGE_CUSTOM = 5;
   */
  CUSTOM = 5,
}

/**
 * Describes the enum api.v1.event.GetNearbyEventsRequest.TimeRange.
 */
export const GetNearbyEventsRequest_TimeRangeSchema: GenEnum<GetNearbyEventsRequest_TimeRange> = /*@__PURE__*/
  enumDesc(file_v1_event_event_requests, 50, 0);

/**
 * GetNearbyEventsResponse is the response for nearby events
 *
 * @generated from message api.v1.event.GetNearbyEventsResponse
 */
export type GetNearbyEventsResponse = Message<"api.v1.event.GetNearbyEventsResponse"> & {
  /**
   * @generated from field: repeated api.v1.event.EventWithDistance nearby_events = 1;
   */
  nearbyEvents: EventWithDistance[];

  /**
   * Context information
   *
   * @generated from field: google.type.LatLng search_location = 2;
   */
  searchLocation?: LatLng;

  /**
   * @generated from field: int32 search_radius_km = 3;
   */
  searchRadiusKm: number;

  /**
   * @generated from field: bool used_user_preferences = 4;
   */
  usedUserPreferences: boolean;

  /**
   * "user_preference", "saved_location", "override"
   *
   * @generated from field: string location_source = 5;
   */
  locationSource: string;

  /**
   * @generated from field: optional api.v1.event.GetNearbyEventsResponse.LocationRecommendation recommendation = 6;
   */
  recommendation?: GetNearbyEventsResponse_LocationRecommendation;
};

/**
 * Describes the message api.v1.event.GetNearbyEventsResponse.
 * Use `create(GetNearbyEventsResponseSchema)` to create a new message.
 */
export const GetNearbyEventsResponseSchema: GenMessage<GetNearbyEventsResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 51);

/**
 * Recommendations
 *
 * @generated from message api.v1.event.GetNearbyEventsResponse.LocationRecommendation
 */
export type GetNearbyEventsResponse_LocationRecommendation = Message<"api.v1.event.GetNearbyEventsResponse.LocationRecommendation"> & {
  /**
   * "Try expanding your search to 50km"
   *
   * @generated from field: string message = 1;
   */
  message: string;

  /**
   * @generated from field: google.type.LatLng suggested_location = 2;
   */
  suggestedLocation?: LatLng;

  /**
   * @generated from field: int32 suggested_radius_km = 3;
   */
  suggestedRadiusKm: number;
};

/**
 * Describes the message api.v1.event.GetNearbyEventsResponse.LocationRecommendation.
 * Use `create(GetNearbyEventsResponse_LocationRecommendationSchema)` to create a new message.
 */
export const GetNearbyEventsResponse_LocationRecommendationSchema: GenMessage<GetNearbyEventsResponse_LocationRecommendation> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 51, 0);

/**
 * GetEventsInUserPreferredAreasRequest is the request to get events in user's preferred areas
 *
 * @generated from message api.v1.event.GetEventsInUserPreferredAreasRequest
 */
export type GetEventsInUserPreferredAreasRequest = Message<"api.v1.event.GetEventsInUserPreferredAreasRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * Filters
   *
   * Default: true
   *
   * @generated from field: bool upcoming_only = 2;
   */
  upcomingOnly: boolean;

  /**
   * Default: false
   *
   * @generated from field: bool available_only = 3;
   */
  availableOnly: boolean;

  /**
   * Look ahead N days (default: 30)
   *
   * @generated from field: int32 days_ahead = 4;
   */
  daysAhead: number;

  /**
   * @generated from field: optional api.v1.event.GetEventsInUserPreferredAreasRequest.SortBy sort_by = 5;
   */
  sortBy?: GetEventsInUserPreferredAreasRequest_SortBy;

  /**
   * Pagination
   *
   * @generated from field: api.v1.common.PaginationRequest pagination = 6;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message api.v1.event.GetEventsInUserPreferredAreasRequest.
 * Use `create(GetEventsInUserPreferredAreasRequestSchema)` to create a new message.
 */
export const GetEventsInUserPreferredAreasRequestSchema: GenMessage<GetEventsInUserPreferredAreasRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 52);

/**
 * Sorting
 *
 * @generated from enum api.v1.event.GetEventsInUserPreferredAreasRequest.SortBy
 */
export enum GetEventsInUserPreferredAreasRequest_SortBy {
  /**
   * @generated from enum value: SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Mix of distance, date, user preferences
   *
   * @generated from enum value: SORT_BY_RELEVANCE = 1;
   */
  RELEVANCE = 1,

  /**
   * Earliest events first
   *
   * @generated from enum value: SORT_BY_DATE = 2;
   */
  DATE = 2,

  /**
   * Closest events first
   *
   * @generated from enum value: SORT_BY_DISTANCE = 3;
   */
  DISTANCE = 3,

  /**
   * Most popular events first
   *
   * @generated from enum value: SORT_BY_POPULAR = 4;
   */
  POPULAR = 4,
}

/**
 * Describes the enum api.v1.event.GetEventsInUserPreferredAreasRequest.SortBy.
 */
export const GetEventsInUserPreferredAreasRequest_SortBySchema: GenEnum<GetEventsInUserPreferredAreasRequest_SortBy> = /*@__PURE__*/
  enumDesc(file_v1_event_event_requests, 52, 0);

/**
 * GetEventsInUserPreferredAreasResponse is the response for events in user's preferred areas
 *
 * @generated from message api.v1.event.GetEventsInUserPreferredAreasResponse
 */
export type GetEventsInUserPreferredAreasResponse = Message<"api.v1.event.GetEventsInUserPreferredAreasResponse"> & {
  /**
   * @generated from field: repeated api.v1.event.EventWithDistance events = 1;
   */
  events: EventWithDistance[];

  /**
   * @generated from field: api.v1.common.Pagination pagination = 2;
   */
  pagination?: Pagination;

  /**
   * @generated from field: repeated api.v1.event.GetEventsInUserPreferredAreasResponse.PreferredAreaContext areas_searched = 3;
   */
  areasSearched: GetEventsInUserPreferredAreasResponse_PreferredAreaContext[];

  /**
   * @generated from field: int32 total_events_found = 4;
   */
  totalEventsFound: number;

  /**
   * Whether user has set location preferences
   *
   * @generated from field: bool has_location_preferences = 5;
   */
  hasLocationPreferences: boolean;
};

/**
 * Describes the message api.v1.event.GetEventsInUserPreferredAreasResponse.
 * Use `create(GetEventsInUserPreferredAreasResponseSchema)` to create a new message.
 */
export const GetEventsInUserPreferredAreasResponseSchema: GenMessage<GetEventsInUserPreferredAreasResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 53);

/**
 * Context about user's preferences used
 *
 * @generated from message api.v1.event.GetEventsInUserPreferredAreasResponse.PreferredAreaContext
 */
export type GetEventsInUserPreferredAreasResponse_PreferredAreaContext = Message<"api.v1.event.GetEventsInUserPreferredAreasResponse.PreferredAreaContext"> & {
  /**
   * "Home area", "Work area", etc.
   *
   * @generated from field: string area_name = 1;
   */
  areaName: string;

  /**
   * @generated from field: google.type.LatLng center_location = 2;
   */
  centerLocation?: LatLng;

  /**
   * @generated from field: int32 radius_km = 3;
   */
  radiusKm: number;

  /**
   * Events found in this area
   *
   * @generated from field: int32 events_count = 4;
   */
  eventsCount: number;
};

/**
 * Describes the message api.v1.event.GetEventsInUserPreferredAreasResponse.PreferredAreaContext.
 * Use `create(GetEventsInUserPreferredAreasResponse_PreferredAreaContextSchema)` to create a new message.
 */
export const GetEventsInUserPreferredAreasResponse_PreferredAreaContextSchema: GenMessage<GetEventsInUserPreferredAreasResponse_PreferredAreaContext> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 53, 0);

/**
 * IsOrgVerifiedRequest is the request to check if an organization is verified
 *
 * @generated from message api.v1.event.IsOrgVerifiedRequest
 */
export type IsOrgVerifiedRequest = Message<"api.v1.event.IsOrgVerifiedRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message api.v1.event.IsOrgVerifiedRequest.
 * Use `create(IsOrgVerifiedRequestSchema)` to create a new message.
 */
export const IsOrgVerifiedRequestSchema: GenMessage<IsOrgVerifiedRequest> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 54);

/**
 * IsOrgVerifiedResponse is the response indicating organization verification status
 *
 * @generated from message api.v1.event.IsOrgVerifiedResponse
 */
export type IsOrgVerifiedResponse = Message<"api.v1.event.IsOrgVerifiedResponse"> & {
  /**
   * @generated from field: bool is_verified = 1;
   */
  isVerified: boolean;
};

/**
 * Describes the message api.v1.event.IsOrgVerifiedResponse.
 * Use `create(IsOrgVerifiedResponseSchema)` to create a new message.
 */
export const IsOrgVerifiedResponseSchema: GenMessage<IsOrgVerifiedResponse> = /*@__PURE__*/
  messageDesc(file_v1_event_event_requests, 55);

/**
 * Location search mode for unified search
 *
 * @generated from enum api.v1.event.LocationSearchMode
 */
export enum LocationSearchMode {
  /**
   * @generated from enum value: LOCATION_SEARCH_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Search within radius of specific location
   *
   * @generated from enum value: LOCATION_SEARCH_MODE_COMMUNITY = 1;
   */
  COMMUNITY = 1,

  /**
   * Search everywhere without location restrictions
   *
   * @generated from enum value: LOCATION_SEARCH_MODE_BEYOND = 2;
   */
  BEYOND = 2,
}

/**
 * Describes the enum api.v1.event.LocationSearchMode.
 */
export const LocationSearchModeSchema: GenEnum<LocationSearchMode> = /*@__PURE__*/
  enumDesc(file_v1_event_event_requests, 0);

/**
 * Sort options for unified search
 *
 * @generated from enum api.v1.event.SearchSortBy
 */
export enum SearchSortBy {
  /**
   * @generated from enum value: SEARCH_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Closest first (only for COMMUNITY mode)
   *
   * @generated from enum value: SEARCH_SORT_BY_DISTANCE = 1;
   */
  DISTANCE = 1,

  /**
   * Most popular/trending
   *
   * @generated from enum value: SEARCH_SORT_BY_TRENDING = 2;
   */
  TRENDING = 2,

  /**
   * Recently created
   *
   * @generated from enum value: SEARCH_SORT_BY_RECENT = 3;
   */
  RECENT = 3,

  /**
   * Most attended/saved
   *
   * @generated from enum value: SEARCH_SORT_BY_POPULAR = 4;
   */
  POPULAR = 4,

  /**
   * Earliest start date first
   *
   * @generated from enum value: SEARCH_SORT_BY_START_DATE = 5;
   */
  START_DATE = 5,
}

/**
 * Describes the enum api.v1.event.SearchSortBy.
 */
export const SearchSortBySchema: GenEnum<SearchSortBy> = /*@__PURE__*/
  enumDesc(file_v1_event_event_requests, 1);

